/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@udemy/graphql';

/** All built-in and custom scalars, mapped to their actual values */

/** Represents the actor who performed the event. */

/** Defines the type of actor performing the event. */
export let ActorType = /*#__PURE__*/function (ActorType) {
  ActorType["EndUser"] = "END_USER";
  ActorType["Impersonation"] = "IMPERSONATION";
  ActorType["Service"] = "SERVICE";
  return ActorType;
}({});

/** Gen AI-related organization settings */

/** Price option for computed price plan. Will be returned for annual plans */

/** An API client */

/** Response from creating an API client containing ApiClient info and client's secret */

/** Response from deleting an API client containing the deleted API Client ID */

/** An API client for an Organization */

/** An API client for a Partner */

/** Input for creating an API client */

/** Article lecture */

/** Article lecture */

/**
 * An Assessment represents a collection of Forms (which are variations of items and orderings of items).
 * A user chooses to take an Assessment. They are then give a Form to take from that Assessment.
 */

/** A unique assignment of an assessment to a user, with optional due date */

/** An attempt of an assessment by a learner */

/** Score stats for an attempt of an assessment */

/** Attempt summary for an assessment with its attempts and remaining attempt count */

/** A domain associated with an assessment */

/** An AssessmentItem contains data about the item a user can interact with. */

/** An  AssessmentItemAttempt is an item related to an Assessment that contains how a user performed in an AssessmentItem. */

/** Input for submitting an attempt of an assessment item */

/** Contains the valid item attempt status for an item attempt. */
export let AssessmentItemAttemptStatus = /*#__PURE__*/function (AssessmentItemAttemptStatus) {
  AssessmentItemAttemptStatus["Correct"] = "CORRECT";
  AssessmentItemAttemptStatus["Incorrect"] = "INCORRECT";
  AssessmentItemAttemptStatus["Skipped"] = "SKIPPED";
  return AssessmentItemAttemptStatus;
}({});

/** Option for multiple-choice or multi-select type questions */

/** Filters used to fetch user assessment items results that are correct, skipped and attempted. */

/** Type of the Assessment item */
export let AssessmentItemType = /*#__PURE__*/function (AssessmentItemType) {
  AssessmentItemType["MultipleChoice"] = "MULTIPLE_CHOICE";
  AssessmentItemType["MultiSelect"] = "MULTI_SELECT";
  return AssessmentItemType;
}({});

/** MetaData for an assessment */

/** A wrapper type to include the recommended Assessment and some additional fields about its recommendation */

/**
 * An AssessmentResults represents a user results for taking an Assessment.
 * items are the attempts of the latest form the User attempted for an Assessment.
 */

/** List of Assessment and additional data about search response */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Detailed metrics for a specific skill/assessment */

/** Input for skills breakdown query */

/** Paginated list for assessment summary list */

/** Sort order options for skills breakdown */

/** Assessment activity data point for a specific day */

/**
 * A 'variant' is an instance/representation of an assessment used for having its own dynamic list of questions (deprecated)
 *
 * There may exist multiple variants of the same assessment, which share the same pool of questions, uniquely ordered between variants. Each variant will have a unique id, and will be associated with one assessment from which the questions are drawn.
 */

/** Top level object to track the progress and results of a user taking an assessment variant (deprecated) */

/** An evaluation of a completed attempt (deprecated) */

/** An asset is a fundamental resource unit (like images, videos, subtitles, texts) for building learning experiences at Udemy. Asset endpoint provides metadata, the storage location, access permission and its type. */

/** Represents an article asset, including download information and article content. */

/** Represents an audio asset, including download information, captions, and DRM status. */

/** Captions are the WebVTT standard files needed for rendering subtitles */

/** Download information for a given asset */

/** Represents an ebook asset */

/** Represents an external link asset, typically used for linking to external resources or websites. */

/** Represents a file asset, including download information and file type. */

/**
 * Categories for file asset types. These categories roughly map to MIME types.
 * See https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/MIME_types/Common_types for details
 */
export let AssetFileType = /*#__PURE__*/function (AssetFileType) {
  AssetFileType["Code"] = "CODE";
  AssetFileType["Document"] = "DOCUMENT";
  AssetFileType["Image"] = "IMAGE";
  AssetFileType["Other"] = "OTHER";
  AssetFileType["Text"] = "TEXT";
  AssetFileType["Zip"] = "ZIP";
  return AssetFileType;
}({});

/** Represents an iframe asset */

/** Represents an imported content asset */

/** Media source provides the info to download and stream the media artifacts */

/** Represents a presentation asset */

/** Represents a source code asset */

/** Status of asset processing. */
export let AssetStatus = /*#__PURE__*/function (AssetStatus) {
  AssetStatus["Failed"] = "FAILED";
  AssetStatus["Processing"] = "PROCESSING";
  AssetStatus["Success"] = "SUCCESS";
  AssetStatus["Unprocessed"] = "UNPROCESSED";
  return AssetStatus;
}({});

/** Thumbnail tracks are used for sneak-peek feature. provides a composite image and a metadata file with a timestamp and cartesian plane co-ordinates of a image rectangle. */

/** Represents a video asset, including download information, captions, and DRM status. */

/** Represents a Video Mashup asset, including download information and file type. */

/** Lecture in the form of just audio (deprecated) */

/** Lecture in the form of just audio (deprecated) */

/** Defines what chat format configuration should be used for assistant messages */

/** Defines the types of events that occurred. */
export let AuditEvent = /*#__PURE__*/function (AuditEvent) {
  AuditEvent["AssignUsersByCsv"] = "ASSIGN_USERS_BY_CSV";
  AuditEvent["GroupCreated"] = "GROUP_CREATED";
  AuditEvent["GroupDeleted"] = "GROUP_DELETED";
  AuditEvent["GroupEdited"] = "GROUP_EDITED";
  AuditEvent["InvitationCreated"] = "INVITATION_CREATED";
  AuditEvent["LicenseActivated"] = "LICENSE_ACTIVATED";
  AuditEvent["LicenseDeactivated"] = "LICENSE_DEACTIVATED";
  AuditEvent["UserActivated"] = "USER_ACTIVATED";
  AuditEvent["UserAnonymized"] = "USER_ANONYMIZED";
  AuditEvent["UserCreated"] = "USER_CREATED";
  AuditEvent["UserDeactivated"] = "USER_DEACTIVATED";
  AuditEvent["UserEmailEdited"] = "USER_EMAIL_EDITED";
  AuditEvent["UserListExportedToCsv"] = "USER_LIST_EXPORTED_TO_CSV";
  AuditEvent["UserPending"] = "USER_PENDING";
  AuditEvent["UserReactivated"] = "USER_REACTIVATED";
  AuditEvent["UserRoleAssigned"] = "USER_ROLE_ASSIGNED";
  AuditEvent["UserRoleEdited"] = "USER_ROLE_EDITED";
  AuditEvent["UserUpdated"] = "USER_UPDATED";
  return AuditEvent;
}({});

/** Input type for filtering logs based on a date time range. */

/** Issued Badge of a user (Assertion in OpenBadge specification) */

/** Response for storing assertion (which is given as external url) for current user */

/** Response for deleting assertion of current user */

/** Issued badges of a user (Assertion in OpenBadge specification) */

/** Search filters for Badge Assertion search */

/** Certification Provider (topic descriptor) for Open Badges */

/** Certification Subject Area (topic descriptor) for Open Badges */

/** The BadgeClass interface. A collection of information about the accomplishment recognized by the Open Badge. It means Certification for the most cases. */

/** Alignment object. An intangible item that describes an alignment between a learning resource and a BadgeClass */

/** Input for BadgeClassAlignment */

/** Descriptive metadata about the achievements necessary to be issued with particular BadgeClass (Certification). */

/** Enrolled learning products for a badge class */

/** Image object of BadgeClass or Issuer */

/** Issuer of BadgeClass. A collection of information that describes the entity or organization */

/** Register a badge issuer for an organization */

/** Response for registering a badge issuer for an organization */

/** Search filters for Organization BadgeClasses search */

/** Search filters for BadgeClass search */

/** Paginated list of BadgeClasses for search response */

/** Wrapped response type for BadgeClass mutations */

/** Input for updating a badge classes by topicId */

/** Input for updating a badge classes by visibilityStatus */

/** Visibility of the badge class on the Udemy platform */
export let BadgeClassVisibilityStatus = /*#__PURE__*/function (BadgeClassVisibilityStatus) {
  BadgeClassVisibilityStatus["Deleted"] = "DELETED";
  BadgeClassVisibilityStatus["Hidden"] = "HIDDEN";
  BadgeClassVisibilityStatus["InstructorIssued"] = "INSTRUCTOR_ISSUED";
  BadgeClassVisibilityStatus["Organization"] = "ORGANIZATION";
  BadgeClassVisibilityStatus["Pending"] = "PENDING";
  BadgeClassVisibilityStatus["Visible"] = "VISIBLE";
  return BadgeClassVisibilityStatus;
}({});

/** Badge enrollment */

/** Response object for badge issuance CSV upload */

/** SubCategory with no additional fields */

/** Represents a badge awarded to a beginner top-rated category topic. */

/** Represents a badge awarded to a beginner top-rated subcategory. */

/** Represents a badge awarded to a beginner top-rated subcategory topic. */

/** Represents a badge awarded to a best seller category topic. */

/** Represents a badge awarded to a best seller subcategory. */

/** Represents a badge awarded to a best seller subcategory topic. */

/** The source of the caption: user-uploaded or automatically generated. */
export let CaptionSource = /*#__PURE__*/function (CaptionSource) {
  CaptionSource["Auto"] = "AUTO";
  CaptionSource["Manual"] = "MANUAL";
  return CaptionSource;
}({});

/** Types of captions */
export let CaptionType = /*#__PURE__*/function (CaptionType) {
  CaptionType["ClosedCaption"] = "CLOSED_CAPTION";
  CaptionType["Subtitle"] = "SUBTITLE";
  return CaptionType;
}({});

/** The Career Accelerator object. */

/** An article associated with a Career Accelerator. */

/** An author of a Career Accelerator article. */

/** A Career object representing a specific career path or field. */

/** A CareerHeroImage object representing hero images associated with a Career. */

/** A CareerImage object representing images associated with a Career. */

/** A curriculum for a Career Accelerator, containing sections and items. */

/** A curriculum item in the Career Accelerator, representing a learning product. */

/** A section in the Career Accelerator curriculum, containing items. */

/** Career accelerator enrollment */

/** Paged career accelerator enrollments */

/** A Frequently Asked Question (FAQ) for a Career Accelerator. */

/** Learning outcome for a Career Accelerator curriculum item. */

/** A subject within a Career Accelerator curriculum item. */

/** A user testimonial for a Career Accelerator. */

/** The source of a Career Accelerator testimonial. */

/** Defines the type of testimonials available for Career Accelerators. */
export let CareerAcceleratorTestimonialType = /*#__PURE__*/function (CareerAcceleratorTestimonialType) {
  CareerAcceleratorTestimonialType["CourseReview"] = "COURSE_REVIEW";
  CareerAcceleratorTestimonialType["ThirdParty"] = "THIRD_PARTY";
  return CareerAcceleratorTestimonialType;
}({});

/** Input type for filtering Career Accelerators. */

/** Cursor paginated Career Accelerators. */

/** Category the Course belongs to */

/** Category navigation list item. */

/** A wrapper type to include the recommended Category and some additional fields about its recommendation */

/** Certification Exam for earning a Badge */

/** Certification Exam for earning a Badge */

/** Certification Exam for earning a Badge */

/** URL to the exam registration page for a certification with its locale (deprecated) */

/** A voucher instance */

/** Primary entity representing a certification exam */

/** FAQ style data for the voucher exam */

/** Paginated certification voucher exams response */

/** Metadata and state for a group of vouchers */

/** FAQ style data for the voucher pool */

/** Paginated certification voucher pools response */

/** Details about a certification provider */

/** Certification provider for voucher exams */
export let CertificationVoucherProviderType = /*#__PURE__*/function (CertificationVoucherProviderType) {
  CertificationVoucherProviderType["Aws"] = "AWS";
  CertificationVoucherProviderType["Comptia"] = "COMPTIA";
  return CertificationVoucherProviderType;
}({});

/** The state of an individual voucher instance */
export let CertificationVoucherState = /*#__PURE__*/function (CertificationVoucherState) {
  CertificationVoucherState["CodeRevealed"] = "CODE_REVEALED";
  CertificationVoucherState["Purchased"] = "PURCHASED";
  CertificationVoucherState["Reserved"] = "RESERVED";
  return CertificationVoucherState;
}({});

/** Possible chat feedback form selections */
export let ChatFeedbackFormSelection = /*#__PURE__*/function (ChatFeedbackFormSelection) {
  ChatFeedbackFormSelection["NotCorrect"] = "NOT_CORRECT";
  ChatFeedbackFormSelection["NotHelpful"] = "NOT_HELPFUL";
  ChatFeedbackFormSelection["NotRelevant"] = "NOT_RELEVANT";
  ChatFeedbackFormSelection["Offensive"] = "OFFENSIVE";
  ChatFeedbackFormSelection["Unspecified"] = "UNSPECIFIED";
  return ChatFeedbackFormSelection;
}({});

/** Possible chat feedback options */
export let ChatFeedbackOption = /*#__PURE__*/function (ChatFeedbackOption) {
  ChatFeedbackOption["Negative"] = "NEGATIVE";
  ChatFeedbackOption["Positive"] = "POSITIVE";
  ChatFeedbackOption["Unspecified"] = "UNSPECIFIED";
  return ChatFeedbackOption;
}({});

/** Possible chat feedback target types to distinguish where feedback originates from. */
export let ChatFeedbackTargetType = /*#__PURE__*/function (ChatFeedbackTargetType) {
  ChatFeedbackTargetType["DiscoveryChat"] = "DISCOVERY_CHAT";
  ChatFeedbackTargetType["InCourseChat"] = "IN_COURSE_CHAT";
  ChatFeedbackTargetType["Unspecified"] = "UNSPECIFIED";
  return ChatFeedbackTargetType;
}({});

/** The ClosedCaptionLanguageCode scalar type. */
export let ClosedCaptionLanguageCode = /*#__PURE__*/function (ClosedCaptionLanguageCode) {
  ClosedCaptionLanguageCode["Af"] = "AF";
  ClosedCaptionLanguageCode["Ak"] = "AK";
  ClosedCaptionLanguageCode["Am"] = "AM";
  ClosedCaptionLanguageCode["Ar"] = "AR";
  ClosedCaptionLanguageCode["ArCc"] = "AR_CC";
  ClosedCaptionLanguageCode["As"] = "AS";
  ClosedCaptionLanguageCode["Az"] = "AZ";
  ClosedCaptionLanguageCode["Be"] = "BE";
  ClosedCaptionLanguageCode["Bg"] = "BG";
  ClosedCaptionLanguageCode["Bm"] = "BM";
  ClosedCaptionLanguageCode["Bn"] = "BN";
  ClosedCaptionLanguageCode["Bo"] = "BO";
  ClosedCaptionLanguageCode["Br"] = "BR";
  ClosedCaptionLanguageCode["Bs"] = "BS";
  ClosedCaptionLanguageCode["Ca"] = "CA";
  ClosedCaptionLanguageCode["Ce"] = "CE";
  ClosedCaptionLanguageCode["Cs"] = "CS";
  ClosedCaptionLanguageCode["Cu"] = "CU";
  ClosedCaptionLanguageCode["Cy"] = "CY";
  ClosedCaptionLanguageCode["Da"] = "DA";
  ClosedCaptionLanguageCode["De"] = "DE";
  ClosedCaptionLanguageCode["DeCc"] = "DE_CC";
  ClosedCaptionLanguageCode["Dz"] = "DZ";
  ClosedCaptionLanguageCode["Ee"] = "EE";
  ClosedCaptionLanguageCode["El"] = "EL";
  ClosedCaptionLanguageCode["En"] = "EN";
  ClosedCaptionLanguageCode["EnCc"] = "EN_CC";
  ClosedCaptionLanguageCode["Eo"] = "EO";
  ClosedCaptionLanguageCode["Es"] = "ES";
  ClosedCaptionLanguageCode["EsCc"] = "ES_CC";
  ClosedCaptionLanguageCode["Et"] = "ET";
  ClosedCaptionLanguageCode["EtCc"] = "ET_CC";
  ClosedCaptionLanguageCode["Eu"] = "EU";
  ClosedCaptionLanguageCode["Fa"] = "FA";
  ClosedCaptionLanguageCode["Ff"] = "FF";
  ClosedCaptionLanguageCode["Fi"] = "FI";
  ClosedCaptionLanguageCode["Fo"] = "FO";
  ClosedCaptionLanguageCode["Fr"] = "FR";
  ClosedCaptionLanguageCode["FrCc"] = "FR_CC";
  ClosedCaptionLanguageCode["Fy"] = "FY";
  ClosedCaptionLanguageCode["Ga"] = "GA";
  ClosedCaptionLanguageCode["Gd"] = "GD";
  ClosedCaptionLanguageCode["Gl"] = "GL";
  ClosedCaptionLanguageCode["Gu"] = "GU";
  ClosedCaptionLanguageCode["Gv"] = "GV";
  ClosedCaptionLanguageCode["Ha"] = "HA";
  ClosedCaptionLanguageCode["He"] = "HE";
  ClosedCaptionLanguageCode["Hi"] = "HI";
  ClosedCaptionLanguageCode["HiCc"] = "HI_CC";
  ClosedCaptionLanguageCode["Hr"] = "HR";
  ClosedCaptionLanguageCode["Hu"] = "HU";
  ClosedCaptionLanguageCode["Hy"] = "HY";
  ClosedCaptionLanguageCode["HyCc"] = "HY_CC";
  ClosedCaptionLanguageCode["Ia"] = "IA";
  ClosedCaptionLanguageCode["Id"] = "ID";
  ClosedCaptionLanguageCode["IdCc"] = "ID_CC";
  ClosedCaptionLanguageCode["Ig"] = "IG";
  ClosedCaptionLanguageCode["Ii"] = "II";
  ClosedCaptionLanguageCode["Is"] = "IS";
  ClosedCaptionLanguageCode["It"] = "IT";
  ClosedCaptionLanguageCode["ItCc"] = "IT_CC";
  ClosedCaptionLanguageCode["Ja"] = "JA";
  ClosedCaptionLanguageCode["JaCc"] = "JA_CC";
  ClosedCaptionLanguageCode["Jv"] = "JV";
  ClosedCaptionLanguageCode["Ka"] = "KA";
  ClosedCaptionLanguageCode["Ki"] = "KI";
  ClosedCaptionLanguageCode["Kk"] = "KK";
  ClosedCaptionLanguageCode["Kl"] = "KL";
  ClosedCaptionLanguageCode["Km"] = "KM";
  ClosedCaptionLanguageCode["Kn"] = "KN";
  ClosedCaptionLanguageCode["Ko"] = "KO";
  ClosedCaptionLanguageCode["KoCc"] = "KO_CC";
  ClosedCaptionLanguageCode["Ks"] = "KS";
  ClosedCaptionLanguageCode["Ku"] = "KU";
  ClosedCaptionLanguageCode["Kw"] = "KW";
  ClosedCaptionLanguageCode["Ky"] = "KY";
  ClosedCaptionLanguageCode["Lb"] = "LB";
  ClosedCaptionLanguageCode["Lg"] = "LG";
  ClosedCaptionLanguageCode["Ln"] = "LN";
  ClosedCaptionLanguageCode["Lo"] = "LO";
  ClosedCaptionLanguageCode["Lt"] = "LT";
  ClosedCaptionLanguageCode["Lu"] = "LU";
  ClosedCaptionLanguageCode["Lv"] = "LV";
  ClosedCaptionLanguageCode["Mg"] = "MG";
  ClosedCaptionLanguageCode["Mi"] = "MI";
  ClosedCaptionLanguageCode["Mk"] = "MK";
  ClosedCaptionLanguageCode["Ml"] = "ML";
  ClosedCaptionLanguageCode["Mn"] = "MN";
  ClosedCaptionLanguageCode["Mr"] = "MR";
  ClosedCaptionLanguageCode["Ms"] = "MS";
  ClosedCaptionLanguageCode["Mt"] = "MT";
  ClosedCaptionLanguageCode["My"] = "MY";
  ClosedCaptionLanguageCode["Nb"] = "NB";
  ClosedCaptionLanguageCode["Nd"] = "ND";
  ClosedCaptionLanguageCode["Ne"] = "NE";
  ClosedCaptionLanguageCode["Nl"] = "NL";
  ClosedCaptionLanguageCode["NlCc"] = "NL_CC";
  ClosedCaptionLanguageCode["Nn"] = "NN";
  ClosedCaptionLanguageCode["No"] = "NO";
  ClosedCaptionLanguageCode["Om"] = "OM";
  ClosedCaptionLanguageCode["Or"] = "OR";
  ClosedCaptionLanguageCode["Os"] = "OS";
  ClosedCaptionLanguageCode["Pa"] = "PA";
  ClosedCaptionLanguageCode["Pl"] = "PL";
  ClosedCaptionLanguageCode["PlCc"] = "PL_CC";
  ClosedCaptionLanguageCode["Ps"] = "PS";
  ClosedCaptionLanguageCode["Pt"] = "PT";
  ClosedCaptionLanguageCode["PtBr"] = "PT_BR";
  ClosedCaptionLanguageCode["PtCc"] = "PT_CC";
  ClosedCaptionLanguageCode["PtPt"] = "PT_PT";
  ClosedCaptionLanguageCode["Qu"] = "QU";
  ClosedCaptionLanguageCode["Rm"] = "RM";
  ClosedCaptionLanguageCode["Rn"] = "RN";
  ClosedCaptionLanguageCode["Ro"] = "RO";
  ClosedCaptionLanguageCode["Ru"] = "RU";
  ClosedCaptionLanguageCode["RuCc"] = "RU_CC";
  ClosedCaptionLanguageCode["Rw"] = "RW";
  ClosedCaptionLanguageCode["Sd"] = "SD";
  ClosedCaptionLanguageCode["Se"] = "SE";
  ClosedCaptionLanguageCode["Sg"] = "SG";
  ClosedCaptionLanguageCode["Si"] = "SI";
  ClosedCaptionLanguageCode["Sk"] = "SK";
  ClosedCaptionLanguageCode["Sl"] = "SL";
  ClosedCaptionLanguageCode["Sn"] = "SN";
  ClosedCaptionLanguageCode["So"] = "SO";
  ClosedCaptionLanguageCode["Sq"] = "SQ";
  ClosedCaptionLanguageCode["Sr"] = "SR";
  ClosedCaptionLanguageCode["Su"] = "SU";
  ClosedCaptionLanguageCode["Sv"] = "SV";
  ClosedCaptionLanguageCode["Sw"] = "SW";
  ClosedCaptionLanguageCode["Ta"] = "TA";
  ClosedCaptionLanguageCode["TaCc"] = "TA_CC";
  ClosedCaptionLanguageCode["Te"] = "TE";
  ClosedCaptionLanguageCode["Tg"] = "TG";
  ClosedCaptionLanguageCode["Th"] = "TH";
  ClosedCaptionLanguageCode["ThCc"] = "TH_CC";
  ClosedCaptionLanguageCode["Ti"] = "TI";
  ClosedCaptionLanguageCode["Tk"] = "TK";
  ClosedCaptionLanguageCode["To"] = "TO";
  ClosedCaptionLanguageCode["Tr"] = "TR";
  ClosedCaptionLanguageCode["TrCc"] = "TR_CC";
  ClosedCaptionLanguageCode["Tt"] = "TT";
  ClosedCaptionLanguageCode["Ug"] = "UG";
  ClosedCaptionLanguageCode["Uk"] = "UK";
  ClosedCaptionLanguageCode["UkCc"] = "UK_CC";
  ClosedCaptionLanguageCode["Ur"] = "UR";
  ClosedCaptionLanguageCode["Uz"] = "UZ";
  ClosedCaptionLanguageCode["Vi"] = "VI";
  ClosedCaptionLanguageCode["ViCc"] = "VI_CC";
  ClosedCaptionLanguageCode["Vo"] = "VO";
  ClosedCaptionLanguageCode["Wo"] = "WO";
  ClosedCaptionLanguageCode["Xh"] = "XH";
  ClosedCaptionLanguageCode["Yi"] = "YI";
  ClosedCaptionLanguageCode["Yo"] = "YO";
  ClosedCaptionLanguageCode["Zh"] = "ZH";
  ClosedCaptionLanguageCode["ZhCc"] = "ZH_CC";
  ClosedCaptionLanguageCode["ZhCn"] = "ZH_CN";
  ClosedCaptionLanguageCode["ZhTw"] = "ZH_TW";
  ClosedCaptionLanguageCode["Zu"] = "ZU";
  return ClosedCaptionLanguageCode;
}({});

/** A micro-content representing a code block */

/** Type of the files withing coding exercise templates */

/** Coding exercise for students to practice their programming */

/** Language possibilities for a coding exercise */
export let CodingExerciseLanguageOption = /*#__PURE__*/function (CodingExerciseLanguageOption) {
  CodingExerciseLanguageOption["Cplusplus"] = "CPLUSPLUS";
  CodingExerciseLanguageOption["Cplusplus_20"] = "CPLUSPLUS_20";
  CodingExerciseLanguageOption["CsvProcessingWithPython"] = "CSV_PROCESSING_WITH_PYTHON";
  CodingExerciseLanguageOption["CSharp"] = "C_SHARP";
  CodingExerciseLanguageOption["CSharp_11"] = "C_SHARP_11";
  CodingExerciseLanguageOption["Html"] = "HTML";
  CodingExerciseLanguageOption["JavascriptEs6"] = "JAVASCRIPT_ES6";
  CodingExerciseLanguageOption["Java_9"] = "JAVA_9";
  CodingExerciseLanguageOption["Java_11"] = "JAVA_11";
  CodingExerciseLanguageOption["Java_17"] = "JAVA_17";
  CodingExerciseLanguageOption["Java_21"] = "JAVA_21";
  CodingExerciseLanguageOption["Kotlin_1_9"] = "KOTLIN_1_9";
  CodingExerciseLanguageOption["Php_5"] = "PHP_5";
  CodingExerciseLanguageOption["Php_7"] = "PHP_7";
  CodingExerciseLanguageOption["Python_3_5"] = "PYTHON_3_5";
  CodingExerciseLanguageOption["Python_3_8"] = "PYTHON_3_8";
  CodingExerciseLanguageOption["Python_3_10"] = "PYTHON_3_10";
  CodingExerciseLanguageOption["React_16"] = "REACT_16";
  CodingExerciseLanguageOption["React_18"] = "REACT_18";
  CodingExerciseLanguageOption["Ruby"] = "RUBY";
  CodingExerciseLanguageOption["R_3_6"] = "R_3_6";
  CodingExerciseLanguageOption["Scipy_1_4NumpyPandasSympyAndScikitLearn_0_23"] = "SCIPY_1_4_NUMPY_PANDAS_SYMPY_AND_SCIKIT_LEARN_0_23";
  CodingExerciseLanguageOption["Sql"] = "SQL";
  CodingExerciseLanguageOption["Sqlite_3"] = "SQLITE_3";
  CodingExerciseLanguageOption["Swift_3"] = "SWIFT_3";
  CodingExerciseLanguageOption["Swift_5"] = "SWIFT_5";
  CodingExerciseLanguageOption["WebDevelopment"] = "WEB_DEVELOPMENT";
  return CodingExerciseLanguageOption;
}({});

/** A wrapper type to include the recommended Coding Exercise and some additional fields about its recommendation */

/** Type of the coding exercise templates */

/** Filtration options for the coding exercise templates */

/** A lab instance running on docker container-based infrastructure */

/** Type representing a group of content for a subscription plan */

/** Stats related to the items in a content collection */

/** Source of a lesson component */
export let ContentSourceType = /*#__PURE__*/function (ContentSourceType) {
  ContentSourceType["Ai"] = "AI";
  ContentSourceType["Instructor"] = "INSTRUCTOR";
  ContentSourceType["Mixed"] = "MIXED";
  return ContentSourceType;
}({});

/** The Course object. */

/** The Course object. */

/** Accreditations */

/** Accreditation types */
export let CourseAccreditationType = /*#__PURE__*/function (CourseAccreditationType) {
  CourseAccreditationType["Cpe"] = "CPE";
  return CourseAccreditationType;
}({});

/** AI generated highlights for a course */

/** Course caption details such as locale, type, and source */

/** A catalog of all courses available to the client */

/** Changes to catalog of all courses available to the client */

/** Category the Course belongs to */

/** Request to copy a course with specified task arguments */

/** Response type for course copy request creation */

/** Asynchronous task for copying a course */

/** Status of a course copy task */
export let CourseCopyTaskStatus = /*#__PURE__*/function (CourseCopyTaskStatus) {
  CourseCopyTaskStatus["Failed"] = "FAILED";
  CourseCopyTaskStatus["InProgress"] = "IN_PROGRESS";
  CourseCopyTaskStatus["Pending"] = "PENDING";
  CourseCopyTaskStatus["Success"] = "SUCCESS";
  return CourseCopyTaskStatus;
}({});

/** Count of the course curriculum content by type */

/** Course enrollment */

/** Enrollments belonging to the course */

/** Filters for course enrollments */

/** Paged course enrollments */

/** Sort order options for course enrollments */

/** Course images by varying dimensions */

/** Instructor for a course */

/** Input for linking an opportunity to a course */

/** Organization specific course properties */

/** Object to store URL and expiration time for course's promo video */

/** Ratings of a course */

/** A wrapper type to include the recommended Course and some additional fields about its recommendation */

/** Additional search context for specific UX cases */

/** Search filters to apply on search request */

/** List of Courses and additional data about search response */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Represents a course search result with additional data about the search response. */

/** Sort order for courses in search response */
export let CourseSearchSortType = /*#__PURE__*/function (CourseSearchSortType) {
  CourseSearchSortType["Rating"] = "RATING";
  CourseSearchSortType["Relevance"] = "RELEVANCE";
  CourseSearchSortType["Reviews"] = "REVIEWS";
  CourseSearchSortType["Time"] = "TIME";
  return CourseSearchSortType;
}({});

/** Trigger types for the course search. */
export let CourseSearchTriggerType = /*#__PURE__*/function (CourseSearchTriggerType) {
  CourseSearchTriggerType["BrowseCategory"] = "BROWSE_CATEGORY";
  CourseSearchTriggerType["BrowseCertification"] = "BROWSE_CERTIFICATION";
  CourseSearchTriggerType["BrowseElevate"] = "BROWSE_ELEVATE";
  CourseSearchTriggerType["BrowseRoleplay"] = "BROWSE_ROLEPLAY";
  CourseSearchTriggerType["BrowseSubcategory"] = "BROWSE_SUBCATEGORY";
  CourseSearchTriggerType["BrowseTopic"] = "BROWSE_TOPIC";
  CourseSearchTriggerType["ChatgptApp"] = "CHATGPT_APP";
  CourseSearchTriggerType["McpServer"] = "MCP_SERVER";
  CourseSearchTriggerType["NarrowingSearch"] = "NARROWING_SEARCH";
  CourseSearchTriggerType["Recommendation"] = "RECOMMENDATION";
  CourseSearchTriggerType["RelatedSearches"] = "RELATED_SEARCHES";
  CourseSearchTriggerType["SearchAutocomplete"] = "SEARCH_AUTOCOMPLETE";
  CourseSearchTriggerType["SearchOriginalQuery"] = "SEARCH_ORIGINAL_QUERY";
  CourseSearchTriggerType["SearchQuerySuggestion"] = "SEARCH_QUERY_SUGGESTION";
  CourseSearchTriggerType["SearchTrendingQuery"] = "SEARCH_TRENDING_QUERY";
  CourseSearchTriggerType["TopSearches"] = "TOP_SEARCHES";
  CourseSearchTriggerType["UserQuery"] = "USER_QUERY";
  return CourseSearchTriggerType;
}({});

/** Section of the course containing all types of curriculum items */

/** A wrapper type to include the recommended Course Section and some additional fields about its recommendation */

/** Response for create snapshot */

/** SubCategory that is part of CourseCategory */

/** Subscription specific course properties */

/** Course taking-related organization settings */

/** Course Variant that belongs to a Course Variation */

/** Course variant that belongs to a Course Variation */

/** A variation of courses */

/** Aggregation of Course Variations */

/** Response for update/create */

/** Reponse for deletion */

/** Input for Course Variation Aggregation */

/** Input for each Course Variation */

/** Option in a Course Variation */

/** Option in a Course Variation */

/** Types of variations */
export let CourseVariationType = /*#__PURE__*/function (CourseVariationType) {
  CourseVariationType["Audience"] = "AUDIENCE";
  CourseVariationType["CourseEdition"] = "COURSE_EDITION";
  CourseVariationType["Language"] = "LANGUAGE";
  CourseVariationType["Topic"] = "TOPIC";
  return CourseVariationType;
}({});

/** Currencies available */
export let CurrencyCode = /*#__PURE__*/function (CurrencyCode) {
  CurrencyCode["Aud"] = "AUD";
  CurrencyCode["Brl"] = "BRL";
  CurrencyCode["Cad"] = "CAD";
  CurrencyCode["Clp"] = "CLP";
  CurrencyCode["Cop"] = "COP";
  CurrencyCode["Dkk"] = "DKK";
  CurrencyCode["Egp"] = "EGP";
  CurrencyCode["Eur"] = "EUR";
  CurrencyCode["Gbp"] = "GBP";
  CurrencyCode["Idr"] = "IDR";
  CurrencyCode["Ils"] = "ILS";
  CurrencyCode["Inr"] = "INR";
  CurrencyCode["Jpy"] = "JPY";
  CurrencyCode["Krw"] = "KRW";
  CurrencyCode["Mxn"] = "MXN";
  CurrencyCode["Myr"] = "MYR";
  CurrencyCode["Ngn"] = "NGN";
  CurrencyCode["Nok"] = "NOK";
  CurrencyCode["Pen"] = "PEN";
  CurrencyCode["Php"] = "PHP";
  CurrencyCode["Pln"] = "PLN";
  CurrencyCode["Ron"] = "RON";
  CurrencyCode["Rub"] = "RUB";
  CurrencyCode["Sgd"] = "SGD";
  CurrencyCode["Thb"] = "THB";
  CurrencyCode["Try"] = "TRY";
  CurrencyCode["Twd"] = "TWD";
  CurrencyCode["Usd"] = "USD";
  CurrencyCode["Vnd"] = "VND";
  CurrencyCode["Zar"] = "ZAR";
  return CurrencyCode;
}({});

/** Curriculum part of a course */

/** Interface for a curriculum item */

/** Input for cursor-based pagination queries. Used to request a specific page of results. */

/** Interface for implementing cursor-based pagination responses. */

/**
 * If a part of the response needs customizations about how it should be rendered on the UI, this interface should be
 * implemented.
 */

/** Price option for computed price plan. Will be returned for daily plans */

/** Represents the type of data transfer */
export let DataTransferType = /*#__PURE__*/function (DataTransferType) {
  DataTransferType["PresignedUrl"] = "PRESIGNED_URL";
  DataTransferType["Pusher"] = "PUSHER";
  return DataTransferType;
}({});

/** Filter used to pass start and end date between which learning activity has to be returned. Date range should be less than or equal to 120 days when granularity is DAY level. */

/** Type representing details about an interval of dates */

/** Supported units of time over which a subscription trial or billing cycle can occur */
export let DateIntervalType = /*#__PURE__*/function (DateIntervalType) {
  DateIntervalType["Day"] = "DAY";
  DateIntervalType["Month"] = "MONTH";
  DateIntervalType["Week"] = "WEEK";
  DateIntervalType["Year"] = "YEAR";
  return DateIntervalType;
}({});

/** An input that accepts a range of dates to filter the data. If the end date is not provided, it will be considered as now. The dates are inclusive */

/** Day of the week for report scheduling */
export let DayOfWeek = /*#__PURE__*/function (DayOfWeek) {
  DayOfWeek["Friday"] = "FRIDAY";
  DayOfWeek["Monday"] = "MONDAY";
  DayOfWeek["Saturday"] = "SATURDAY";
  DayOfWeek["Sunday"] = "SUNDAY";
  DayOfWeek["Thursday"] = "THURSDAY";
  DayOfWeek["Tuesday"] = "TUESDAY";
  DayOfWeek["Wednesday"] = "WEDNESDAY";
  return DayOfWeek;
}({});

/** Instruction level of the course */
export let DifficultyLevel = /*#__PURE__*/function (DifficultyLevel) {
  DifficultyLevel["AllLevels"] = "ALL_LEVELS";
  DifficultyLevel["Beginner"] = "BEGINNER";
  DifficultyLevel["Expert"] = "EXPERT";
  DifficultyLevel["Intermediate"] = "INTERMEDIATE";
  return DifficultyLevel;
}({});

/** definition of different discount source types */
export let DiscountSourceType = /*#__PURE__*/function (DiscountSourceType) {
  DiscountSourceType["GeneralCoupon"] = "GENERAL_COUPON";
  DiscountSourceType["InstructorCoupon"] = "INSTRUCTOR_COUPON";
  DiscountSourceType["UdemyCoupon"] = "UDEMY_COUPON";
  return DiscountSourceType;
}({});

/** The content of a component defined in the CMS */

/** The dynamic web content query filter options */

/** The dynamic web image object. This combines the image URL and the alt text for the image for a11y purposes. */

/** The specific page type for the dynamic web content. This is important for narrowing down the content in the CMS to where Marketing wants to render it. */
export let DynamicWebContentPageType = /*#__PURE__*/function (DynamicWebContentPageType) {
  DynamicWebContentPageType["LoggedOutHomePage"] = "LOGGED_OUT_HOME_PAGE";
  DynamicWebContentPageType["PersonalPlanLandingPage"] = "PERSONAL_PLAN_LANDING_PAGE";
  DynamicWebContentPageType["RequestDemoForm"] = "REQUEST_DEMO_FORM";
  return DynamicWebContentPageType;
}({});

/** Lecture in form of an EBook (deprecated) */

/** Lecture in form of an EBook (deprecated) */

/** A record of user's enrollment to a learning product */

/** Response object for archiving an enrollment. */

/** Response object for enrollment creation */

/** Source of the enrollment */
export let EnrollmentSourceType = /*#__PURE__*/function (EnrollmentSourceType) {
  EnrollmentSourceType["Purchase"] = "PURCHASE";
  EnrollmentSourceType["Subscription"] = "SUBSCRIPTION";
  return EnrollmentSourceType;
}({});

/** Response object for unarchiving an enrollment. */

/** Input for enrolling to learning product */

/** Learning product type input */
export let EnrollmentsLearningProductInputType = /*#__PURE__*/function (EnrollmentsLearningProductInputType) {
  EnrollmentsLearningProductInputType["BadgeClass"] = "BADGE_CLASS";
  EnrollmentsLearningProductInputType["CareerAccelerator"] = "CAREER_ACCELERATOR";
  EnrollmentsLearningProductInputType["Course"] = "COURSE";
  return EnrollmentsLearningProductInputType;
}({});

/** Represents the entity who was affected by the event. */

/** Defines the type of entity who was affected by the event. */
export let EntityType = /*#__PURE__*/function (EntityType) {
  EntityType["EndUser"] = "END_USER";
  EntityType["Group"] = "GROUP";
  EntityType["License"] = "LICENSE";
  EntityType["Na"] = "NA";
  return EntityType;
}({});

/** Lecture that refers to an external source (deprecated) */

/** Lecture that refers to an external source (deprecated) */

/** Stores realtime attribute like build_number->20220322_v1 */

/** Holds assigned feature variant  */

/** Holds filters for feature variant assignments */

/** Feedback object */

/** Input to create Feedback */

/** Response for storing a feedback */

/** Polymorphic object to represent what the feedback is being applied to */

/** Possible feedback options */
export let FeedbackOption = /*#__PURE__*/function (FeedbackOption) {
  FeedbackOption["Negative"] = "NEGATIVE";
  FeedbackOption["Positive"] = "POSITIVE";
  FeedbackOption["Unselected"] = "UNSELECTED";
  return FeedbackOption;
}({});

/** Possible object targets to apply the feedback to */
export let FeedbackTargetType = /*#__PURE__*/function (FeedbackTargetType) {
  FeedbackTargetType["CourseSection"] = "COURSE_SECTION";
  FeedbackTargetType["DiscoveryChat"] = "DISCOVERY_CHAT";
  FeedbackTargetType["InCourseChat"] = "IN_COURSE_CHAT";
  FeedbackTargetType["LearningAssistantChatMessage"] = "LEARNING_ASSISTANT_CHAT_MESSAGE";
  FeedbackTargetType["Lecture"] = "LECTURE";
  return FeedbackTargetType;
}({});

/** Lecture in the form of a single file (deprecated) */

/** Lecture in the form of a single file (deprecated) */

/** Fill in the blanks question. No options, question text has placeholders for user to fill in */

/** Represents types of hands-on learning experiences available in a course. These ribbons indicate interactive learning features that enhance the course experience. */
export let HandsOnRibbonType = /*#__PURE__*/function (HandsOnRibbonType) {
  HandsOnRibbonType["CodingExercises"] = "CODING_EXERCISES";
  HandsOnRibbonType["HandsOnPractices"] = "HANDS_ON_PRACTICES";
  HandsOnRibbonType["Labs"] = "LABS";
  HandsOnRibbonType["PracticeTests"] = "PRACTICE_TESTS";
  HandsOnRibbonType["Quiz"] = "QUIZ";
  HandsOnRibbonType["RolePlay"] = "ROLE_PLAY";
  HandsOnRibbonType["Workspace"] = "WORKSPACE";
  return HandsOnRibbonType;
}({});

/** Represents a badge awarded to a hot and new learning product. */

/** Instructor for a learning product */

/** Instructor's account balance */

/** Instructor's account issues */

/** Instructor Content Opportunity object  */

/** Display rule of the content opportunity */
export let InstructorContentOpportunityDisplayRule = /*#__PURE__*/function (InstructorContentOpportunityDisplayRule) {
  InstructorContentOpportunityDisplayRule["AllInstructors"] = "ALL_INSTRUCTORS";
  InstructorContentOpportunityDisplayRule["Exclude"] = "EXCLUDE";
  InstructorContentOpportunityDisplayRule["InternalOnly"] = "INTERNAL_ONLY";
  InstructorContentOpportunityDisplayRule["IpOnly"] = "IP_ONLY";
  InstructorContentOpportunityDisplayRule["NoLongerAPriority"] = "NO_LONGER_A_PRIORITY";
  return InstructorContentOpportunityDisplayRule;
}({});

/** Filters for ContentOpportunity */

/** Level of the content opportunity */
export let InstructorContentOpportunityLevel = /*#__PURE__*/function (InstructorContentOpportunityLevel) {
  InstructorContentOpportunityLevel["AllLevels"] = "ALL_LEVELS";
  InstructorContentOpportunityLevel["AnyLevel"] = "ANY_LEVEL";
  InstructorContentOpportunityLevel["Beginner"] = "BEGINNER";
  InstructorContentOpportunityLevel["Expert"] = "EXPERT";
  InstructorContentOpportunityLevel["Intermediate"] = "INTERMEDIATE";
  return InstructorContentOpportunityLevel;
}({});

/** Response for creating a course opportunity mapping (Linking an opportunity to a course) */

/** Priority level of the content opportunity */
export let InstructorContentOpportunityPriority = /*#__PURE__*/function (InstructorContentOpportunityPriority) {
  InstructorContentOpportunityPriority["High"] = "HIGH";
  InstructorContentOpportunityPriority["Low"] = "LOW";
  InstructorContentOpportunityPriority["Medium"] = "MEDIUM";
  return InstructorContentOpportunityPriority;
}({});

/** Paginated response for content opportunity search */

/** Sort order for ContentOpportunities */
export let InstructorContentOpportunitySortType = /*#__PURE__*/function (InstructorContentOpportunitySortType) {
  InstructorContentOpportunitySortType["Priority"] = "PRIORITY";
  InstructorContentOpportunitySortType["Time"] = "TIME";
  return InstructorContentOpportunitySortType;
}({});

/** Type of the content opportunity */
export let InstructorContentOpportunityType = /*#__PURE__*/function (InstructorContentOpportunityType) {
  InstructorContentOpportunityType["FirstMover"] = "FIRST_MOVER";
  InstructorContentOpportunityType["OrgRequest"] = "ORG_REQUEST";
  InstructorContentOpportunityType["Specialized"] = "SPECIALIZED";
  InstructorContentOpportunityType["Trending"] = "TRENDING";
  return InstructorContentOpportunityType;
}({});

/** Response for deleting a course opportunity mapping (Unlinking an opportunity from a course) */

/** Instructor images by varying dimensions */

/** Represent learner metrics. Every learner metric has a value and total learner */

/** A representation of a practice-test for instructor insights */

/** Metrics of a Practice Test */

/** A representation of a practice-test question for instructor insights */

/** Choice of a question inside a practice test */

/** Type of an incorrect answer at the Practice Test. */
export let InstructorInsightPracticeTestQuestionChoiceIncorrectType = /*#__PURE__*/function (InstructorInsightPracticeTestQuestionChoiceIncorrectType) {
  InstructorInsightPracticeTestQuestionChoiceIncorrectType["CommonlySelected"] = "COMMONLY_SELECTED";
  return InstructorInsightPracticeTestQuestionChoiceIncorrectType;
}({});

/** Insight metrics of an answer */

/** Insight metrics of a question inside a practice test */

/** Type of the quality level of a Practice Test Question. */
export let InstructorInsightPracticeTestQuestionQualityLevel = /*#__PURE__*/function (InstructorInsightPracticeTestQuestionQualityLevel) {
  InstructorInsightPracticeTestQuestionQualityLevel["Bad"] = "BAD";
  InstructorInsightPracticeTestQuestionQualityLevel["Good"] = "GOOD";
  InstructorInsightPracticeTestQuestionQualityLevel["Medium"] = "MEDIUM";
  InstructorInsightPracticeTestQuestionQualityLevel["NotEnoughData"] = "NOT_ENOUGH_DATA";
  return InstructorInsightPracticeTestQuestionQualityLevel;
}({});

/** Status of a question of a Practice Test at a date */
export let InstructorInsightPracticeTestQuestionStatus = /*#__PURE__*/function (InstructorInsightPracticeTestQuestionStatus) {
  InstructorInsightPracticeTestQuestionStatus["Active"] = "ACTIVE";
  InstructorInsightPracticeTestQuestionStatus["Deleted"] = "DELETED";
  return InstructorInsightPracticeTestQuestionStatus;
}({});

/** Type of a question at the Practice Test. It can be multiple choice, multiple selection or fill in the blanks. */
export let InstructorInsightPracticeTestQuestionType = /*#__PURE__*/function (InstructorInsightPracticeTestQuestionType) {
  InstructorInsightPracticeTestQuestionType["FillInTheBlanks"] = "FILL_IN_THE_BLANKS";
  InstructorInsightPracticeTestQuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
  InstructorInsightPracticeTestQuestionType["MultipleSelection"] = "MULTIPLE_SELECTION";
  return InstructorInsightPracticeTestQuestionType;
}({});

/** Practice test version data */

/** Instructor's payout */

/** Instructor's payouts paged */

/** A wrapper type to include the recommended Instructor and some additional fields about its recommendation */

/** The Lab object. */

/** An instance of a lab's workspace for the user to interact with */

/** The operational state of a lab instance */
export let LabInstanceStatus = /*#__PURE__*/function (LabInstanceStatus) {
  LabInstanceStatus["AdminKilled"] = "ADMIN_KILLED";
  LabInstanceStatus["AdminKilling"] = "ADMIN_KILLING";
  LabInstanceStatus["Deactivated"] = "DEACTIVATED";
  LabInstanceStatus["Error"] = "ERROR";
  LabInstanceStatus["Isolating"] = "ISOLATING";
  LabInstanceStatus["Killed"] = "KILLED";
  LabInstanceStatus["Killing"] = "KILLING";
  LabInstanceStatus["Pending"] = "PENDING";
  LabInstanceStatus["Queued"] = "QUEUED";
  LabInstanceStatus["Running"] = "RUNNING";
  LabInstanceStatus["Starting"] = "STARTING";
  LabInstanceStatus["Stopped"] = "STOPPED";
  LabInstanceStatus["Stopping"] = "STOPPING";
  return LabInstanceStatus;
}({});

/** Instructor for a lab */

/** MetaData for a lab */

/** Limits established for learners to constrain lab consumption */

/** Quota usage is determined by discrete integer values */

/** Rolling window of time to include user interactions with labs */
export let LabQuotaTimespanType = /*#__PURE__*/function (LabQuotaTimespanType) {
  LabQuotaTimespanType["Week"] = "WEEK";
  return LabQuotaTimespanType;
}({});

/** Entity used for calculating user quotas */
export let LabQuotaType = /*#__PURE__*/function (LabQuotaType) {
  LabQuotaType["SecondsConsumed"] = "SECONDS_CONSUMED";
  return LabQuotaType;
}({});

/** Specifies how a quota usage is represented */

/** A wrapper type to include the recommended Lab and some additional fields about its recommendation */

/** List of Labs and additional data about search response */

/** Messages administered internally at Udemy to be displayed for users inside labs */

/** The message alert level */
export let LabSystemMessageAlertLevel = /*#__PURE__*/function (LabSystemMessageAlertLevel) {
  LabSystemMessageAlertLevel["Error"] = "ERROR";
  LabSystemMessageAlertLevel["Information"] = "INFORMATION";
  LabSystemMessageAlertLevel["Success"] = "SUCCESS";
  LabSystemMessageAlertLevel["Warning"] = "WARNING";
  return LabSystemMessageAlertLevel;
}({});

/** A task to be completed by users within the lab's workspace */

/** A required or optional resource for completing a lab task */

/** The type of a lab task resource */
export let LabTaskResourceType = /*#__PURE__*/function (LabTaskResourceType) {
  LabTaskResourceType["Asset"] = "ASSET";
  LabTaskResourceType["Documentation"] = "DOCUMENTATION";
  LabTaskResourceType["HowTo"] = "HOW_TO";
  LabTaskResourceType["SolutionSourceCode"] = "SOLUTION_SOURCE_CODE";
  LabTaskResourceType["Unspecified"] = "UNSPECIFIED";
  return LabTaskResourceType;
}({});

/** The publishing status of a lab task */
export let LabTaskStatus = /*#__PURE__*/function (LabTaskStatus) {
  LabTaskStatus["Draft"] = "DRAFT";
  LabTaskStatus["Published"] = "PUBLISHED";
  return LabTaskStatus;
}({});

/** The LanguageCode scalar type as defined by ISO 639-1. */
export let LanguageCode = /*#__PURE__*/function (LanguageCode) {
  LanguageCode["Af"] = "AF";
  LanguageCode["Ak"] = "AK";
  LanguageCode["Am"] = "AM";
  LanguageCode["Ar"] = "AR";
  LanguageCode["As"] = "AS";
  LanguageCode["Az"] = "AZ";
  LanguageCode["Be"] = "BE";
  LanguageCode["Bg"] = "BG";
  LanguageCode["Bm"] = "BM";
  LanguageCode["Bn"] = "BN";
  LanguageCode["Bo"] = "BO";
  LanguageCode["Br"] = "BR";
  LanguageCode["Bs"] = "BS";
  LanguageCode["Ca"] = "CA";
  LanguageCode["Ce"] = "CE";
  LanguageCode["Cs"] = "CS";
  LanguageCode["Cu"] = "CU";
  LanguageCode["Cy"] = "CY";
  LanguageCode["Da"] = "DA";
  LanguageCode["De"] = "DE";
  LanguageCode["Dz"] = "DZ";
  LanguageCode["Ee"] = "EE";
  LanguageCode["El"] = "EL";
  LanguageCode["En"] = "EN";
  LanguageCode["Eo"] = "EO";
  LanguageCode["Es"] = "ES";
  LanguageCode["Et"] = "ET";
  LanguageCode["Eu"] = "EU";
  LanguageCode["Fa"] = "FA";
  LanguageCode["Ff"] = "FF";
  LanguageCode["Fi"] = "FI";
  LanguageCode["Fo"] = "FO";
  LanguageCode["Fr"] = "FR";
  LanguageCode["Fy"] = "FY";
  LanguageCode["Ga"] = "GA";
  LanguageCode["Gd"] = "GD";
  LanguageCode["Gl"] = "GL";
  LanguageCode["Gu"] = "GU";
  LanguageCode["Gv"] = "GV";
  LanguageCode["Ha"] = "HA";
  LanguageCode["He"] = "HE";
  LanguageCode["Hi"] = "HI";
  LanguageCode["Hr"] = "HR";
  LanguageCode["Hu"] = "HU";
  LanguageCode["Hy"] = "HY";
  LanguageCode["Ia"] = "IA";
  LanguageCode["Id"] = "ID";
  LanguageCode["Ig"] = "IG";
  LanguageCode["Ii"] = "II";
  LanguageCode["Is"] = "IS";
  LanguageCode["It"] = "IT";
  LanguageCode["Ja"] = "JA";
  LanguageCode["Jv"] = "JV";
  LanguageCode["Ka"] = "KA";
  LanguageCode["Ki"] = "KI";
  LanguageCode["Kk"] = "KK";
  LanguageCode["Kl"] = "KL";
  LanguageCode["Km"] = "KM";
  LanguageCode["Kn"] = "KN";
  LanguageCode["Ko"] = "KO";
  LanguageCode["Ks"] = "KS";
  LanguageCode["Ku"] = "KU";
  LanguageCode["Kw"] = "KW";
  LanguageCode["Ky"] = "KY";
  LanguageCode["Lb"] = "LB";
  LanguageCode["Lg"] = "LG";
  LanguageCode["Ln"] = "LN";
  LanguageCode["Lo"] = "LO";
  LanguageCode["Lt"] = "LT";
  LanguageCode["Lu"] = "LU";
  LanguageCode["Lv"] = "LV";
  LanguageCode["Mg"] = "MG";
  LanguageCode["Mi"] = "MI";
  LanguageCode["Mk"] = "MK";
  LanguageCode["Ml"] = "ML";
  LanguageCode["Mn"] = "MN";
  LanguageCode["Mr"] = "MR";
  LanguageCode["Ms"] = "MS";
  LanguageCode["Mt"] = "MT";
  LanguageCode["My"] = "MY";
  LanguageCode["Nb"] = "NB";
  LanguageCode["Nd"] = "ND";
  LanguageCode["Ne"] = "NE";
  LanguageCode["Nl"] = "NL";
  LanguageCode["Nn"] = "NN";
  LanguageCode["No"] = "NO";
  LanguageCode["Om"] = "OM";
  LanguageCode["Or"] = "OR";
  LanguageCode["Os"] = "OS";
  LanguageCode["Pa"] = "PA";
  LanguageCode["Pl"] = "PL";
  LanguageCode["Ps"] = "PS";
  LanguageCode["Pt"] = "PT";
  LanguageCode["PtBr"] = "PT_BR";
  LanguageCode["PtPt"] = "PT_PT";
  LanguageCode["Qu"] = "QU";
  LanguageCode["Rm"] = "RM";
  LanguageCode["Rn"] = "RN";
  LanguageCode["Ro"] = "RO";
  LanguageCode["Ru"] = "RU";
  LanguageCode["Rw"] = "RW";
  LanguageCode["Sd"] = "SD";
  LanguageCode["Se"] = "SE";
  LanguageCode["Sg"] = "SG";
  LanguageCode["Si"] = "SI";
  LanguageCode["Sk"] = "SK";
  LanguageCode["Sl"] = "SL";
  LanguageCode["Sn"] = "SN";
  LanguageCode["So"] = "SO";
  LanguageCode["Sq"] = "SQ";
  LanguageCode["Sr"] = "SR";
  LanguageCode["Su"] = "SU";
  LanguageCode["Sv"] = "SV";
  LanguageCode["Sw"] = "SW";
  LanguageCode["Ta"] = "TA";
  LanguageCode["Te"] = "TE";
  LanguageCode["Tg"] = "TG";
  LanguageCode["Th"] = "TH";
  LanguageCode["Ti"] = "TI";
  LanguageCode["Tk"] = "TK";
  LanguageCode["To"] = "TO";
  LanguageCode["Tr"] = "TR";
  LanguageCode["Tt"] = "TT";
  LanguageCode["Ug"] = "UG";
  LanguageCode["Uk"] = "UK";
  LanguageCode["Ur"] = "UR";
  LanguageCode["Uz"] = "UZ";
  LanguageCode["Vi"] = "VI";
  LanguageCode["Vo"] = "VO";
  LanguageCode["Wo"] = "WO";
  LanguageCode["Xh"] = "XH";
  LanguageCode["Yi"] = "YI";
  LanguageCode["Yo"] = "YO";
  LanguageCode["Zh"] = "ZH";
  LanguageCode["ZhCn"] = "ZH_CN";
  LanguageCode["ZhTw"] = "ZH_TW";
  LanguageCode["Zu"] = "ZU";
  return LanguageCode;
}({});

/** Scope of the data for the insights. It can be for all courses or for ub courses only. If it is for ub courses only, the data will be filtered by the courses that are for the ub only. If it is for all courses, the data will not be filtered */
export let LearnerChannel = /*#__PURE__*/function (LearnerChannel) {
  LearnerChannel["All"] = "ALL";
  LearnerChannel["Ub"] = "UB";
  return LearnerChannel;
}({});

/** Represents the learning activity period like daily or monthly and the corresponding date in value. For monthly, day portion in the value will be 1st of the month. */

/** Contains records of time spent in a learning activity */

/** Filters used to fetch summary of learning activity. */

/** Represents the learning activity in trend view. */

/** Filters used to fetch learning activity. */

/** Base message item entity - add here any fields shared across all item types */

/** Input for sending an audio chat message */

/** Represents code blocks that can be shared within a chat message */

/** The programming languages available in Learning Assistant code blocks */
export let LearningAssistantChatCodeBlockLanguage = /*#__PURE__*/function (LearningAssistantChatCodeBlockLanguage) {
  LearningAssistantChatCodeBlockLanguage["Assembly"] = "ASSEMBLY";
  LearningAssistantChatCodeBlockLanguage["BatchFile"] = "BATCH_FILE";
  LearningAssistantChatCodeBlockLanguage["C"] = "C";
  LearningAssistantChatCodeBlockLanguage["Clojure"] = "CLOJURE";
  LearningAssistantChatCodeBlockLanguage["Cmake"] = "CMAKE";
  LearningAssistantChatCodeBlockLanguage["Cobol"] = "COBOL";
  LearningAssistantChatCodeBlockLanguage["Coffeescript"] = "COFFEESCRIPT";
  LearningAssistantChatCodeBlockLanguage["Cpp"] = "CPP";
  LearningAssistantChatCodeBlockLanguage["Csharp"] = "CSHARP";
  LearningAssistantChatCodeBlockLanguage["Css"] = "CSS";
  LearningAssistantChatCodeBlockLanguage["Csv"] = "CSV";
  LearningAssistantChatCodeBlockLanguage["Dart"] = "DART";
  LearningAssistantChatCodeBlockLanguage["Default"] = "DEFAULT";
  LearningAssistantChatCodeBlockLanguage["Dm"] = "DM";
  LearningAssistantChatCodeBlockLanguage["Dockerfile"] = "DOCKERFILE";
  LearningAssistantChatCodeBlockLanguage["Elixir"] = "ELIXIR";
  LearningAssistantChatCodeBlockLanguage["Erlang"] = "ERLANG";
  LearningAssistantChatCodeBlockLanguage["Fortran"] = "FORTRAN";
  LearningAssistantChatCodeBlockLanguage["Go"] = "GO";
  LearningAssistantChatCodeBlockLanguage["Groovy"] = "GROOVY";
  LearningAssistantChatCodeBlockLanguage["Haskell"] = "HASKELL";
  LearningAssistantChatCodeBlockLanguage["Html"] = "HTML";
  LearningAssistantChatCodeBlockLanguage["Ini"] = "INI";
  LearningAssistantChatCodeBlockLanguage["Java"] = "JAVA";
  LearningAssistantChatCodeBlockLanguage["Javascript"] = "JAVASCRIPT";
  LearningAssistantChatCodeBlockLanguage["Json"] = "JSON";
  LearningAssistantChatCodeBlockLanguage["Julia"] = "JULIA";
  LearningAssistantChatCodeBlockLanguage["Kotlin"] = "KOTLIN";
  LearningAssistantChatCodeBlockLanguage["Lisp"] = "LISP";
  LearningAssistantChatCodeBlockLanguage["Lua"] = "LUA";
  LearningAssistantChatCodeBlockLanguage["Makefile"] = "MAKEFILE";
  LearningAssistantChatCodeBlockLanguage["Markdown"] = "MARKDOWN";
  LearningAssistantChatCodeBlockLanguage["Matlab"] = "MATLAB";
  LearningAssistantChatCodeBlockLanguage["ObjectiveC"] = "OBJECTIVE_C";
  LearningAssistantChatCodeBlockLanguage["Ocaml"] = "OCAML";
  LearningAssistantChatCodeBlockLanguage["Pascal"] = "PASCAL";
  LearningAssistantChatCodeBlockLanguage["Perl"] = "PERL";
  LearningAssistantChatCodeBlockLanguage["Php"] = "PHP";
  LearningAssistantChatCodeBlockLanguage["Powershell"] = "POWERSHELL";
  LearningAssistantChatCodeBlockLanguage["Prolog"] = "PROLOG";
  LearningAssistantChatCodeBlockLanguage["Python"] = "PYTHON";
  LearningAssistantChatCodeBlockLanguage["R"] = "R";
  LearningAssistantChatCodeBlockLanguage["Ruby"] = "RUBY";
  LearningAssistantChatCodeBlockLanguage["Rust"] = "RUST";
  LearningAssistantChatCodeBlockLanguage["Scala"] = "SCALA";
  LearningAssistantChatCodeBlockLanguage["Shell"] = "SHELL";
  LearningAssistantChatCodeBlockLanguage["Sql"] = "SQL";
  LearningAssistantChatCodeBlockLanguage["Swift"] = "SWIFT";
  LearningAssistantChatCodeBlockLanguage["Tex"] = "TEX";
  LearningAssistantChatCodeBlockLanguage["Toml"] = "TOML";
  LearningAssistantChatCodeBlockLanguage["Typescript"] = "TYPESCRIPT";
  LearningAssistantChatCodeBlockLanguage["Verilog"] = "VERILOG";
  LearningAssistantChatCodeBlockLanguage["VisualBasic"] = "VISUAL_BASIC";
  LearningAssistantChatCodeBlockLanguage["Xml"] = "XML";
  LearningAssistantChatCodeBlockLanguage["Yaml"] = "YAML";
  return LearningAssistantChatCodeBlockLanguage;
}({});

/** Input for generic chat context */

/** Input for role play context */

/** Input for chat message history context */

/** Input for chat message context */

/** Input to submit a chat feedback form */

/** Input to submit a chat feedback */

/** Submit chat feedback response */

/** Base interface for file objects shared via the chat assistant */

/** Represents a file message shared in the chat, retrievable from learning assistant cloud storage */

/** Represents a list of files that can be shared within a chat message */

/** Response for initiating a chat session */

/** Represents Udemy instructors given by the assistant  */

/** Input for feeding chat context */

/** Response for the mutation to send chat interactions */

/** Interaction type for the client interaction with the Learning Assistant */
export let LearningAssistantChatInteractionType = /*#__PURE__*/function (LearningAssistantChatInteractionType) {
  LearningAssistantChatInteractionType["Generic"] = "GENERIC";
  LearningAssistantChatInteractionType["PracticeTestAnswerChecked"] = "PRACTICE_TEST_ANSWER_CHECKED";
  LearningAssistantChatInteractionType["PracticeTestQuestionPresented"] = "PRACTICE_TEST_QUESTION_PRESENTED";
  LearningAssistantChatInteractionType["QuizAnswerChecked"] = "QUIZ_ANSWER_CHECKED";
  LearningAssistantChatInteractionType["QuizQuestionPresented"] = "QUIZ_QUESTION_PRESENTED";
  return LearningAssistantChatInteractionType;
}({});

/** Represent learning products that can be shared within a chat message (deprecated) */

/** Represent learning products or curriculum items that can be shared within a chat message */

/** Represent a chat message */

/** Union of possible chat message items */

/** Represents the roles of chat messages */
export let LearningAssistantChatMessageRole = /*#__PURE__*/function (LearningAssistantChatMessageRole) {
  LearningAssistantChatMessageRole["Assistant"] = "ASSISTANT";
  LearningAssistantChatMessageRole["User"] = "USER";
  return LearningAssistantChatMessageRole;
}({});

/** Response for sending a chat message */

/** Paginated chat messages */

/** Represents different types of chat sessions */
export let LearningAssistantChatName = /*#__PURE__*/function (LearningAssistantChatName) {
  LearningAssistantChatName["DiscoveryChat"] = "DISCOVERY_CHAT";
  LearningAssistantChatName["GenericChat"] = "GENERIC_CHAT";
  LearningAssistantChatName["InCourseChat"] = "IN_COURSE_CHAT";
  LearningAssistantChatName["IqgChat"] = "IQG_CHAT";
  LearningAssistantChatName["LearnerProfileChat"] = "LEARNER_PROFILE_CHAT";
  LearningAssistantChatName["RolePlayChat"] = "ROLE_PLAY_CHAT";
  LearningAssistantChatName["SkillsChat"] = "SKILLS_CHAT";
  return LearningAssistantChatName;
}({});

/** Common fields returned by chat-related responses */

/** Common error structure for Learning Assistant chat responses */

/** Response for terminating the chat session */

/** Represent a text message that can be shared within a chat message */

/** Input for sending a text chat message */

/** Input for requesting a new upload URL */

/** Represent a curriculum item that extends an actual curriculum item */

/** Error codes for Learning Assistant chat operations */
export let LearningAssistantErrorCode = /*#__PURE__*/function (LearningAssistantErrorCode) {
  LearningAssistantErrorCode["ErrorCodeChatContextNotFound"] = "ERROR_CODE_CHAT_CONTEXT_NOT_FOUND";
  LearningAssistantErrorCode["ErrorCodeChatIdRequired"] = "ERROR_CODE_CHAT_ID_REQUIRED";
  LearningAssistantErrorCode["ErrorCodeChatMessageRequired"] = "ERROR_CODE_CHAT_MESSAGE_REQUIRED";
  LearningAssistantErrorCode["ErrorCodeChatSessionExpired"] = "ERROR_CODE_CHAT_SESSION_EXPIRED";
  LearningAssistantErrorCode["ErrorCodeCourseIdRequired"] = "ERROR_CODE_COURSE_ID_REQUIRED";
  LearningAssistantErrorCode["ErrorCodeEmptyAudioFileContent"] = "ERROR_CODE_EMPTY_AUDIO_FILE_CONTENT";
  LearningAssistantErrorCode["ErrorCodeFileUnsupportedContentType"] = "ERROR_CODE_FILE_UNSUPPORTED_CONTENT_TYPE";
  LearningAssistantErrorCode["ErrorCodeInternalError"] = "ERROR_CODE_INTERNAL_ERROR";
  LearningAssistantErrorCode["ErrorCodeInvalidCourseId"] = "ERROR_CODE_INVALID_COURSE_ID";
  LearningAssistantErrorCode["ErrorCodeMaxUserMessageLength"] = "ERROR_CODE_MAX_USER_MESSAGE_LENGTH";
  LearningAssistantErrorCode["ErrorCodeModerationFlagged"] = "ERROR_CODE_MODERATION_FLAGGED";
  LearningAssistantErrorCode["ErrorCodeNotAuthorized"] = "ERROR_CODE_NOT_AUTHORIZED";
  LearningAssistantErrorCode["ErrorCodePiiDetected"] = "ERROR_CODE_PII_DETECTED";
  LearningAssistantErrorCode["ErrorCodeProcessingIsFailed"] = "ERROR_CODE_PROCESSING_IS_FAILED";
  LearningAssistantErrorCode["ErrorCodeQuotaLimitExceeded"] = "ERROR_CODE_QUOTA_LIMIT_EXCEEDED";
  LearningAssistantErrorCode["ErrorCodeSessionMessageLimitExceeded"] = "ERROR_CODE_SESSION_MESSAGE_LIMIT_EXCEEDED";
  LearningAssistantErrorCode["ErrorCodeSessionNotFound"] = "ERROR_CODE_SESSION_NOT_FOUND";
  LearningAssistantErrorCode["ErrorCodeSinceIsRequired"] = "ERROR_CODE_SINCE_IS_REQUIRED";
  LearningAssistantErrorCode["ErrorCodeTooManyRequest"] = "ERROR_CODE_TOO_MANY_REQUEST";
  LearningAssistantErrorCode["ErrorCodeUnspecified"] = "ERROR_CODE_UNSPECIFIED";
  LearningAssistantErrorCode["ErrorCodeUserIdDetectedInMessage"] = "ERROR_CODE_USER_ID_DETECTED_IN_MESSAGE";
  LearningAssistantErrorCode["ErrorCodeUserIdNotFound"] = "ERROR_CODE_USER_ID_NOT_FOUND";
  return LearningAssistantErrorCode;
}({});

/** Input representing a file context passed into the chat, including file metadata and its temporary access URL. */

/** Supported file MIME types */
export let LearningAssistantFileMimeType = /*#__PURE__*/function (LearningAssistantFileMimeType) {
  LearningAssistantFileMimeType["Gif"] = "GIF";
  LearningAssistantFileMimeType["Jpeg"] = "JPEG";
  LearningAssistantFileMimeType["Pdf"] = "PDF";
  LearningAssistantFileMimeType["Png"] = "PNG";
  LearningAssistantFileMimeType["Webp"] = "WEBP";
  return LearningAssistantFileMimeType;
}({});

/** Response containing a presigned URL for either uploading or downloading a file, depending on the context of the request. For upload: the URL is used with PUT. For download: the URL is used with GET */

/** List of presigned URLs */

/** Represent a learning assistant-specific learning product that extends an actual learning product */

/** Union of possible chat message item types that can be shared within a chat message item */

/** User checks (submits) a practice test answer */

/** User sees a practice test question */

/** User checks (submits) a quiz answer (text fields are exactly as seen on the UI) */

/** User sees a quiz question (text fields are exactly as seen on the UI) */

/** Enhanced suggested prompt with categorization for future UI differentiation */

/** Represents the category of a suggested prompt matches backend enum */
export let LearningAssistantSuggestedPromptCategory = /*#__PURE__*/function (LearningAssistantSuggestedPromptCategory) {
  LearningAssistantSuggestedPromptCategory["AiaCapability"] = "AIA_CAPABILITY";
  LearningAssistantSuggestedPromptCategory["ContentBasedPrompts"] = "CONTENT_BASED_PROMPTS";
  LearningAssistantSuggestedPromptCategory["Unspecified"] = "UNSPECIFIED";
  return LearningAssistantSuggestedPromptCategory;
}({});

/** Represents all pages that support displaying suggested prompts */
export let LearningAssistantSuggestedPromptPageSource = /*#__PURE__*/function (LearningAssistantSuggestedPromptPageSource) {
  LearningAssistantSuggestedPromptPageSource["AiAssistantPage"] = "AI_ASSISTANT_PAGE";
  LearningAssistantSuggestedPromptPageSource["CourseLandingPage"] = "COURSE_LANDING_PAGE";
  LearningAssistantSuggestedPromptPageSource["CourseTakingPage"] = "COURSE_TAKING_PAGE";
  LearningAssistantSuggestedPromptPageSource["LoggedInHomePage"] = "LOGGED_IN_HOME_PAGE";
  LearningAssistantSuggestedPromptPageSource["SearchResultsPage"] = "SEARCH_RESULTS_PAGE";
  return LearningAssistantSuggestedPromptPageSource;
}({});

/** Represents the subcategory of a suggested prompt matches backend enum */
export let LearningAssistantSuggestedPromptSubcategory = /*#__PURE__*/function (LearningAssistantSuggestedPromptSubcategory) {
  LearningAssistantSuggestedPromptSubcategory["CodeDebugging"] = "CODE_DEBUGGING";
  LearningAssistantSuggestedPromptSubcategory["Faq"] = "FAQ";
  LearningAssistantSuggestedPromptSubcategory["LectureBased"] = "LECTURE_BASED";
  LearningAssistantSuggestedPromptSubcategory["LectureSearch"] = "LECTURE_SEARCH";
  LearningAssistantSuggestedPromptSubcategory["LectureSummarization"] = "LECTURE_SUMMARIZATION";
  LearningAssistantSuggestedPromptSubcategory["Others"] = "OTHERS";
  LearningAssistantSuggestedPromptSubcategory["Quiz"] = "QUIZ";
  LearningAssistantSuggestedPromptSubcategory["SkillsFocused"] = "SKILLS_FOCUSED";
  LearningAssistantSuggestedPromptSubcategory["Unspecified"] = "UNSPECIFIED";
  return LearningAssistantSuggestedPromptSubcategory;
}({});

/** Paginated suggested prompts */

/** Types of Udemy Instructors that the Assistant might respond with */

/** Generic interaction that enables faster implementation of new interaction types */

/** Represents BE entities that are not yet mapped to a GQL type */

/** Input for retrieving presigned URLs for previously uploaded files */

/** Quota (limit) that a user can have when interacting with the Learning Assistant */

/** Quota usage is determined by discrete integer values */

/** Response for fetching user quota */

/** Window of time to include user interactions with the Learning Assistant. Also, it represents the frequency by which the user quota is reset */
export let LearningAssistantUserQuotaTimespanType = /*#__PURE__*/function (LearningAssistantUserQuotaTimespanType) {
  LearningAssistantUserQuotaTimespanType["Day"] = "DAY";
  LearningAssistantUserQuotaTimespanType["Month"] = "MONTH";
  LearningAssistantUserQuotaTimespanType["Week"] = "WEEK";
  return LearningAssistantUserQuotaTimespanType;
}({});

/** Entity used for calculating user quotas */
export let LearningAssistantUserQuotaType = /*#__PURE__*/function (LearningAssistantUserQuotaType) {
  LearningAssistantUserQuotaType["MessageCount"] = "MESSAGE_COUNT";
  return LearningAssistantUserQuotaType;
}({});

/** Specifies how a quota usage is represented */

/** All active user quotas segregated by whether they have exceeded or not */

/** A learning objective is a brief statements that describe what students will be expected to learn. */

/** Represents the types of activities we can map to a Learning Objective. */

/** Allows the user to set the activity id's and the activity types they want to query for. */

/** Represent the types of activities we can map to a Learning Objective. */
export let LearningObjectiveActivityTypeInput = /*#__PURE__*/function (LearningObjectiveActivityTypeInput) {
  LearningObjectiveActivityTypeInput["AssessmentQuestion"] = "ASSESSMENT_QUESTION";
  LearningObjectiveActivityTypeInput["Course"] = "COURSE";
  LearningObjectiveActivityTypeInput["Lab"] = "LAB";
  LearningObjectiveActivityTypeInput["LabTask"] = "LAB_TASK";
  LearningObjectiveActivityTypeInput["Lecture"] = "LECTURE";
  return LearningObjectiveActivityTypeInput;
}({});

/** This holds data to create a learning objective */

/** Response for updating a Learning Objective */

/** The learning path object. */

/** Catalog of all learning paths available to the client */

/** Changes to catalog of all learning paths available to the client since last sync */

/** Collection of curriculum items presented in a learning path as a one item */

/** Response for creating/updating a learning path from skills */

/** Learning path enrollment */

/** Instructor for a Learning Path */

/** Learning Path Item can be Course, Lab, Assessment, Learning Path Resource, and Course Portion */

/** A wrapper type to include the recommended Learning Path and some additional fields about its recommendation */

/** Learning Path Resource represents a link to another resource */

/** Search filters to apply on path search request */

/** List of LearningPath and additional data about search response */

/** Learning Path Section represents a collection of items in a learning path */

/** All partner's content collection items that are available, currently just course */

/** Represents a request to access a specific learning product */

/** Response for approval operation on learning product access requests */

/** Represents the response for creating a learning product access request */

/** Status codes representing the result of processing access requests */
export let LearningProductAccessRequestProcessCode = /*#__PURE__*/function (LearningProductAccessRequestProcessCode) {
  LearningProductAccessRequestProcessCode["NoSeatsAvailable"] = "NO_SEATS_AVAILABLE";
  LearningProductAccessRequestProcessCode["RequestNotFound"] = "REQUEST_NOT_FOUND";
  LearningProductAccessRequestProcessCode["Success"] = "SUCCESS";
  LearningProductAccessRequestProcessCode["UnknownError"] = "UNKNOWN_ERROR";
  return LearningProductAccessRequestProcessCode;
}({});

/** Represents the result of processing an individual access request */

/** Response for rejection operation on learning product access requests */

/** Status of a learning product access request */
export let LearningProductAccessRequestStatus = /*#__PURE__*/function (LearningProductAccessRequestStatus) {
  LearningProductAccessRequestStatus["Approved"] = "APPROVED";
  LearningProductAccessRequestStatus["AutoApproved"] = "AUTO_APPROVED";
  LearningProductAccessRequestStatus["Pending"] = "PENDING";
  LearningProductAccessRequestStatus["Rejected"] = "REJECTED";
  return LearningProductAccessRequestStatus;
}({});

/** Paginated response for learning product access requests */

/** Represents a badge awarded to a learning product. */

/** Input for getting badge classes by learning products */

/** Type of learning product. */
export let LearningProductType = /*#__PURE__*/function (LearningProductType) {
  LearningProductType["Assessment"] = "ASSESSMENT";
  LearningProductType["BadgeClass"] = "BADGE_CLASS";
  LearningProductType["CareerAccelerator"] = "CAREER_ACCELERATOR";
  LearningProductType["Course"] = "COURSE";
  LearningProductType["Lab"] = "LAB";
  LearningProductType["LearningPath"] = "LEARNING_PATH";
  LearningProductType["PracticeTest"] = "PRACTICE_TEST";
  return LearningProductType;
}({});

/** A collection of learning products for a partner */

/** The LearningReminder object. */

/** Calendar type of the learning reminder */
export let LearningReminderCalendarType = /*#__PURE__*/function (LearningReminderCalendarType) {
  LearningReminderCalendarType["Apple"] = "APPLE";
  LearningReminderCalendarType["Google"] = "GOOGLE";
  LearningReminderCalendarType["Other"] = "OTHER";
  LearningReminderCalendarType["Outlook"] = "OUTLOOK";
  return LearningReminderCalendarType;
}({});

/** Response for creating or updating a learning reminder */

/** Response for deleting a learning reminder */

/** Input for creating and updating a learning reminder */

/** Input for learning product of the learning reminder */

/** Notification method of the learning reminder */
export let LearningReminderNotificationMethod = /*#__PURE__*/function (LearningReminderNotificationMethod) {
  LearningReminderNotificationMethod["Email"] = "EMAIL";
  LearningReminderNotificationMethod["Push"] = "PUSH";
  return LearningReminderNotificationMethod;
}({});

/** Paginated learning reminders of the user */

/** The testimonial given relevant to a learning item or event */

/** The Learning Testimonials query filter options */

/** The specific page type for the Learning Testimonial. This is important for narrowing down the testimonial content in the CMS to where Marketing wants to render it. (Other pages will be added in the future, e.g., Personal Plan, etc) */
export let LearningTestimonialPageType = /*#__PURE__*/function (LearningTestimonialPageType) {
  LearningTestimonialPageType["LoggedOutHomePage"] = "LOGGED_OUT_HOME_PAGE";
  return LearningTestimonialPageType;
}({});

/** The source of the learning testimonial */

/** Type of Learning Testimonial */
export let LearningTestimonialType = /*#__PURE__*/function (LearningTestimonialType) {
  LearningTestimonialType["CaseStudy"] = "CASE_STUDY";
  LearningTestimonialType["CourseReview"] = "COURSE_REVIEW";
  LearningTestimonialType["ThirdParty"] = "THIRD_PARTY";
  return LearningTestimonialType;
}({});

/** Represents a lecture type  */

/** Represents a lecture type  */

/** Lecture images by varying dimensions */

/** A wrapper type to include the recommended Lecture and some additional fields about its recommendation */

/** List of LectureResults and additional data about search response */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Identifies each result for lecture search. */

/** A lesson associated with a learning product */

/** A rich article whose fragments can map to timestamps within the playable media */

/** A fragment of an article with possible mapping to the lesson's playable media */

/** Polymorphic Article Fragment Content */

/** A flexible identification for a lesson */

/** Input type for providing a lesson id */

/** The types of a LessonId */
export let LessonIdType = /*#__PURE__*/function (LessonIdType) {
  LessonIdType["AssetId"] = "ASSET_ID";
  LessonIdType["Uuid"] = "UUID";
  return LessonIdType;
}({});

/** License-related organization settings */

/** License pool */

/** Count of Active Users per Product Type per License Pool */

/** Response for a license pool create or update mutation */

/** Response for a license pool delete mutation */

/** The input used for creating and updating a license pool */

/** Product type license count */

/** The input used for describing a product type license count */

/** Response for a license pool update preview mutation */

/** Response for License Pool users move mutation */

/** License Pools users per SubscriptionPlanProductType of the pool */

/** Filters for the License Pools queries */

/** Enum for locale config options */
export let LocaleConfig = /*#__PURE__*/function (LocaleConfig) {
  LocaleConfig["LessonLocale"] = "LESSON_LOCALE";
  LocaleConfig["UserLocale"] = "USER_LOCALE";
  return LocaleConfig;
}({});

/** Input type for providing a locale configuration */

/** A micro-content representing markdown */

/** Single bullet item with optional icon. */

/** Call-to-action button with destination link. */

/**
 * Shared interface for all marketing card types in V1.
 * Ensures consistent core fields across different card implementations.
 */

/** Standard header copy used across marketing components. */

/** Marketing card with full background image and text content overlaid on top. */

/**
 * Marketing card with image positioned at the top and text content below.
 * Implements the shared MarketingCardV1 interface.
 */

/** Image asset used in marketing components. */

/** Two-column marketing section with intro copy on the left and a fixed row of cards on the right. */

/** Small pill UI element used in other components (icon + label). */

/** Two-column marketing section with copy with bullets on the left and an image on the right. */

/** Two-column hero with marketing copy on the left and a cards carousel on the right. */

/** Two-column marketing section with featured popular topic on the left and categorized topics on the right. */

/** Tabbed interface with header content where topic tabs control course card display. */

/** A category of topic with a header and list of topics. */

/** Current User */

/** Enrollments of the current user */

/** Enrollments of the current user */

/** Enrollments of the current user */

/** Enrollments of the current user */

/** Enrollments of the current user */

/** The available media source MIME types for video/audio streaming and playback. */
export let MediaSourceType = /*#__PURE__*/function (MediaSourceType) {
  MediaSourceType["ApplicationDashXml"] = "APPLICATION_DASH_XML";
  MediaSourceType["ApplicationXMpegurl"] = "APPLICATION_X_MPEGURL";
  MediaSourceType["AudioMp3"] = "AUDIO_MP3";
  MediaSourceType["VideoMp4"] = "VIDEO_MP4";
  return MediaSourceType;
}({});

/** Represents a key-value pair in metadata. */

/** Money */

/** Money input */

/** Price option for computed price plan. Will be returned for monthly plans */

/** Input for querying more RecommendationContextSections from a RecommendationContext */

/** Response returned when more RecommendationContextSections are queried for a RecommendationContext */

/** Input for querying more RecommendationItems from a RecommendationUnit */

/** Response returned when more RecommendationItems are queried for a RecommendationUnit */

/** Multi-select question. Several available options, with one or more correct answer options. */

/** Represents multiple choice quiz context */

/** Multiple-choice question. Several available options, with one and only one correct answer. */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Item in navigation list. */

/** Identifies the name of the navigation list. */
export let NavListName = /*#__PURE__*/function (NavListName) {
  NavListName["LinkBar"] = "LINK_BAR";
  NavListName["Main"] = "MAIN";
  return NavListName;
}({});

/** Represents a badge awarded to a new learning product. */

/** Details of Occupation */

/** User is assigning occupation to themself */

/** Occupation group type */

/** Current user assigning existing occupation group. */

/** Shows page search results of occupation */

/** Current user assigning user provided occupation. */

/** A wrapper type to include the recommended Occupation and some additional fields about its recommendation */

/** Filters for occupation search */

/** The OpenBadgeClass object. This implements the BadgeClass. */

/** A UB organization */

/** Represents an audit log entry for an organization. */

/** Input type for filtering organization logs. */

/** Background images for an organization */

/** The OrganizationBadgeClass object. This implements the BadgeClass. This has a few more issuer organization related fields. */

/** Response for creating a new organization badge class */

/** Response for deleting an organization badge class */

/** Additional details of the organization badge */

/** Input for creating a new organization badge class */

/** Response for updating an existing organization badge class */

/** Criteria for earning an organization badge by custom input */

/** Custom earning criteria input */

/** Interface for criteria for earning an organization badge */

/** Earning criteria input combined */

/** Criteria type for earning an organization badge */
export let OrganizationBadgeEarningCriteriaType = /*#__PURE__*/function (OrganizationBadgeEarningCriteriaType) {
  OrganizationBadgeEarningCriteriaType["Custom"] = "CUSTOM";
  OrganizationBadgeEarningCriteriaType["LearningProduct"] = "LEARNING_PRODUCT";
  return OrganizationBadgeEarningCriteriaType;
}({});

/** Criteria that is empty for earning an organization badge */

/** Criteria for earning an organization badge by learning product */

/** Learning Product earning criteria input */

/** Status of an OrganizationBadgeClass */
export let OrganizationBadgeStatus = /*#__PURE__*/function (OrganizationBadgeStatus) {
  OrganizationBadgeStatus["Draft"] = "DRAFT";
  OrganizationBadgeStatus["Expired"] = "EXPIRED";
  OrganizationBadgeStatus["Published"] = "PUBLISHED";
  return OrganizationBadgeStatus;
}({});

/** Input for creation of organizations */

/** Response for Organization creation operation */

/** Favicon images for an organization */

/** Images for an organization */

/** Response object for Organization Insight progress buckets */

/** Response object for Organization Insight minutes range */

/** An input that accepts a start and end minutes */

/** Response object for Organization Insight learner count */

/** An input that accepts a range of dates to filter the data and buckets with start and end minutes */

/** Represents the organization learning goal */

/** Represents the input to create learning goal of an organization */

/** Represents the organization learning goal create response */

/** Represents the organization learning goal deactivate response */

/** Progress made by learners in organization towards the goal */

/** Represents the stats of learning goal of an organization */

/** Status of an organization learning goal */
export let OrganizationLearningGoalStatus = /*#__PURE__*/function (OrganizationLearningGoalStatus) {
  OrganizationLearningGoalStatus["Active"] = "ACTIVE";
  OrganizationLearningGoalStatus["Inactive"] = "INACTIVE";
  return OrganizationLearningGoalStatus;
}({});

/** Learning Path object that belongs to an organization */

/** Logo images for an organization */

/** Represents the each organization notification preference */

/** Represents the notification preferences of an organization */

/** Represents the organization notification save response */

/** Role-based organization notifications to group organization notifications by role */
export let OrganizationNotificationRoleType = /*#__PURE__*/function (OrganizationNotificationRoleType) {
  OrganizationNotificationRoleType["Everyone"] = "EVERYONE";
  OrganizationNotificationRoleType["GroupAdmins"] = "GROUP_ADMINS";
  OrganizationNotificationRoleType["Learners"] = "LEARNERS";
  return OrganizationNotificationRoleType;
}({});

/** A notification preference belongs to organization */

/** A setting for an organization */

/** The setting names available for an organization */
export let OrganizationSettingName = /*#__PURE__*/function (OrganizationSettingName) {
  OrganizationSettingName["GenaiAiAssistantEnabled"] = "GENAI_AI_ASSISTANT_ENABLED";
  OrganizationSettingName["GenaiOptIn"] = "GENAI_OPT_IN";
  OrganizationSettingName["GenaiSkillsMappingEnabled"] = "GENAI_SKILLS_MAPPING_ENABLED";
  OrganizationSettingName["MsTeamsShare"] = "MS_TEAMS_SHARE";
  OrganizationSettingName["RecurringBilling"] = "RECURRING_BILLING";
  OrganizationSettingName["SendDataToMarketo"] = "SEND_DATA_TO_MARKETO";
  OrganizationSettingName["SentimentSurvey"] = "SENTIMENT_SURVEY";
  OrganizationSettingName["SlackShare"] = "SLACK_SHARE";
  OrganizationSettingName["TpV2Enabled"] = "TP_V2_ENABLED";
  OrganizationSettingName["WorkplaceShare"] = "WORKPLACE_SHARE";
  return OrganizationSettingName;
}({});

/** Input for setting overrides on organization settings. Only a specific set of settings (reflected in the params) can be overridden; in particular not all settings are meant to be self-serve, and some of them can only be set from Udemy. */

/** Response of setting overrides on organization settings. It returns all settings for the organization. */

/** Organization settings */

/** Organization Subscription */

/** Input for the Organization Subscription Creation */

/** Response for Adding Subscriptions to Organization */

/** Type of Trial Subscription for Organizations */
export let OrganizationSubscriptionTrialType = /*#__PURE__*/function (OrganizationSubscriptionTrialType) {
  OrganizationSubscriptionTrialType["IsFreeTrial"] = "IS_FREE_TRIAL";
  return OrganizationSubscriptionTrialType;
}({});

/** Type of an organization */
export let OrganizationType = /*#__PURE__*/function (OrganizationType) {
  OrganizationType["UdemyBusiness"] = "UDEMY_BUSINESS";
  OrganizationType["UdemyBusinessChina"] = "UDEMY_BUSINESS_CHINA";
  OrganizationType["UdemyGovernment"] = "UDEMY_GOVERNMENT";
  return OrganizationType;
}({});

/** Group identifiers within an organization to allow filtering the report data */

/** Object that describes the type and status of license assigned to a user in an organization */

/** Object that describes the status of license assigned to a user in an organization */
export let OrganizationUserLicenseStatus = /*#__PURE__*/function (OrganizationUserLicenseStatus) {
  OrganizationUserLicenseStatus["Active"] = "ACTIVE";
  OrganizationUserLicenseStatus["Inactive"] = "INACTIVE";
  return OrganizationUserLicenseStatus;
}({});

/** Object that describes the type of license assigned to a user in an organization */
export let OrganizationUserLicenseType = /*#__PURE__*/function (OrganizationUserLicenseType) {
  OrganizationUserLicenseType["Basic"] = "BASIC";
  OrganizationUserLicenseType["Pro"] = "PRO";
  return OrganizationUserLicenseType;
}({});

/** Filters for the organizationUserLicenses query */

/** Overrideable settings related to Licenses */

/** Interface for implementing paginated results */

/** A Partner */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Enum for different payment method types */
export let PaymentMethodType = /*#__PURE__*/function (PaymentMethodType) {
  PaymentMethodType["Cheque"] = "CHEQUE";
  PaymentMethodType["Jpmorgan"] = "JPMORGAN";
  PaymentMethodType["Payoneer"] = "PAYONEER";
  PaymentMethodType["Paypal"] = "PAYPAL";
  PaymentMethodType["Tipalti"] = "TIPALTI";
  PaymentMethodType["Wire"] = "WIRE";
  return PaymentMethodType;
}({});

/** Input for payout exists search filter */

/** Enum for different payout statuses */
export let PayoutStatusType = /*#__PURE__*/function (PayoutStatusType) {
  PayoutStatusType["Blocked"] = "BLOCKED";
  PayoutStatusType["Cancelled"] = "CANCELLED";
  PayoutStatusType["Derecognized"] = "DERECOGNIZED";
  PayoutStatusType["Failed"] = "FAILED";
  PayoutStatusType["Initial"] = "INITIAL";
  PayoutStatusType["PartiallySuccess"] = "PARTIALLY_SUCCESS";
  PayoutStatusType["Pending"] = "PENDING";
  PayoutStatusType["Processing"] = "PROCESSING";
  PayoutStatusType["Queuing"] = "QUEUING";
  PayoutStatusType["ReadyToPay"] = "READY_TO_PAY";
  PayoutStatusType["Success"] = "SUCCESS";
  PayoutStatusType["Unclaimed"] = "UNCLAIMED";
  PayoutStatusType["Unpaid"] = "UNPAID";
  return PayoutStatusType;
}({});

/** Player-related organization settings */

/** Popular topic */

/** Topic SubCategory */

/** Assigment test with multiple-choice and free-from questions reviewed by instructors */

/** Practice test that is more detailed than a Quiz */

/** Represents the selected choices of practice test context */

/** Represents practice test context for in-course chat */

/** Filters for practice test insights */

/** Presentation Lecture for Udemy Business */

/** Presentation Lecture for Udemy Business */

/** Price of the course, free or paid */
export let PriceOption = /*#__PURE__*/function (PriceOption) {
  PriceOption["Free"] = "FREE";
  PriceOption["Paid"] = "PAID";
  return PriceOption;
}({});

/** The LearningPath only available for PRO subscriptions */

/** Instructor-friendly error message for failed assets */

/** The numbers of users which have attained each level */

/** Change in proficiency level counts over time */

/** Represents the pusher config */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Possible question types for practice test questions. */
export let QuestionType = /*#__PURE__*/function (QuestionType) {
  QuestionType["FillInTheBlank"] = "FILL_IN_THE_BLANK";
  QuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
  QuestionType["MultipleSelection"] = "MULTIPLE_SELECTION";
  return QuestionType;
}({});

/** Quiz with simple questions and multiple choice / multi select answers */

/** An attempt of a quiz */

/** Represents quiz context for in-course chat */

/** A quiz item */

/** An option for a quiz item */

/** Response for a quiz item in an attempt */

/** Status of the response for a quiz item in an attempt */
export let QuizItemResponseStatus = /*#__PURE__*/function (QuizItemResponseStatus) {
  QuizItemResponseStatus["Correct"] = "CORRECT";
  QuizItemResponseStatus["Incorrect"] = "INCORRECT";
  QuizItemResponseStatus["NotAnswered"] = "NOT_ANSWERED";
  QuizItemResponseStatus["Skipped"] = "SKIPPED";
  return QuizItemResponseStatus;
}({});

/** Input request to submit an answer for a quiz item */

/** Paginated response for quiz items in a quiz */

/**
 * This is a top level grouping comprising all recommendations queried by a context code (ID of this object).
 *
 * Usually, this corresponds to the entire page of the application. In that case, there would be just one recommendation
 * context on a single page. The biggest advantage of serving all recommendations in one response, is the ability to
 * run unit ranking and deduplication comprehensively for the entire recommendation context.
 *
 * Even though, it is common to see a single page of the application uses only one recommendation context, it is not an
 * obligation. The 'page' and 'context' concepts are decoupled. Having multiple contexts on a page might be acceptable
 * if the trade-offs about compromising comprehensive ranking and deduplication are evaluated.
 *
 * RecommendationContext doesn't directly contain a list of RecommendationItems. Instead, it has a list of sections.
 * The UI should follow this grouping while rendering the recommendations.
 */

/** All information required to query a recommendation context */

/** Response returned when a RecommendationContext is queried */

/** RecommendationContext comprises multiple sections. Sections might be a RecommendationUnit or RecommendationUnitGroup. */

/**
 * A recommendation item comprises the actual entity (ex. course) to be recommended and some additional fields required
 * specifically by the recommendations domain.
 */

/** Input version of RecommendationItem type to specify a recommendation item in queries */

/** Currently supported RecommendationItem types */
export let RecommendationItemType = /*#__PURE__*/function (RecommendationItemType) {
  RecommendationItemType["Assessment"] = "ASSESSMENT";
  RecommendationItemType["Category"] = "CATEGORY";
  RecommendationItemType["CodingExercise"] = "CODING_EXERCISE";
  RecommendationItemType["Course"] = "COURSE";
  RecommendationItemType["CourseSection"] = "COURSE_SECTION";
  RecommendationItemType["Instructor"] = "INSTRUCTOR";
  RecommendationItemType["Lab"] = "LAB";
  RecommendationItemType["Label"] = "LABEL";
  RecommendationItemType["LearningPath"] = "LEARNING_PATH";
  RecommendationItemType["Lecture"] = "LECTURE";
  RecommendationItemType["Occupation"] = "OCCUPATION";
  RecommendationItemType["Subcategory"] = "SUBCATEGORY";
  return RecommendationItemType;
}({});

/** A type to specify what objects were used as a source object (seed) for a recommendation unit */

/** Input version of RecommendationSourceObject */

/** Currently supported recommendation source (aka. seed) object types */
export let RecommendationSourceObjectType = /*#__PURE__*/function (RecommendationSourceObjectType) {
  RecommendationSourceObjectType["Category"] = "CATEGORY";
  RecommendationSourceObjectType["Collection"] = "COLLECTION";
  RecommendationSourceObjectType["Course"] = "COURSE";
  RecommendationSourceObjectType["Instructor"] = "INSTRUCTOR";
  RecommendationSourceObjectType["Label"] = "LABEL";
  RecommendationSourceObjectType["Language"] = "LANGUAGE";
  RecommendationSourceObjectType["Lecture"] = "LECTURE";
  RecommendationSourceObjectType["ManagementOccupation"] = "MANAGEMENT_OCCUPATION";
  RecommendationSourceObjectType["Occupation"] = "OCCUPATION";
  RecommendationSourceObjectType["OccupationGroup"] = "OCCUPATION_GROUP";
  RecommendationSourceObjectType["Subcategory"] = "SUBCATEGORY";
  return RecommendationSourceObjectType;
}({});

/**
 * Finest grained grouping of recommendations. Each recommendation unit corresponds to a specific algorithm,
 * source object (recommendation seed), and recommendation item type.
 */

/** Group of units that should be presented together. */

/** Date range for the report generation */
export let RelativeDateRange = /*#__PURE__*/function (RelativeDateRange) {
  RelativeDateRange["Last_3Months"] = "LAST_3_MONTHS";
  RelativeDateRange["Last_7Days"] = "LAST_7_DAYS";
  RelativeDateRange["Last_30Days"] = "LAST_30_DAYS";
  RelativeDateRange["LastYear"] = "LAST_YEAR";
  RelativeDateRange["SinceActivated"] = "SINCE_ACTIVATED";
  return RelativeDateRange;
}({});

/** Report job request */

/** Input type for report job */

/** Type of report job that can be scheduled or generated. */
export let ReportJobType = /*#__PURE__*/function (ReportJobType) {
  ReportJobType["CoursesExport"] = "COURSES_EXPORT";
  ReportJobType["CourseActivity"] = "COURSE_ACTIVITY";
  ReportJobType["CustomCourseExport"] = "CUSTOM_COURSE_EXPORT";
  ReportJobType["PublicPathExport"] = "PUBLIC_PATH_EXPORT";
  ReportJobType["RatingsReviews"] = "RATINGS_REVIEWS";
  ReportJobType["SubscriptionCourseExport"] = "SUBSCRIPTION_COURSE_EXPORT";
  ReportJobType["UdemyPathExport"] = "UDEMY_PATH_EXPORT";
  ReportJobType["UsersActive"] = "USERS_ACTIVE";
  ReportJobType["UsersAll"] = "USERS_ALL";
  ReportJobType["UsersDeactivated"] = "USERS_DEACTIVATED";
  ReportJobType["UsersGroupAdmin"] = "USERS_GROUP_ADMIN";
  ReportJobType["UsersGroupAdminInvitations"] = "USERS_GROUP_ADMIN_INVITATIONS";
  ReportJobType["UsersInvitations"] = "USERS_INVITATIONS";
  ReportJobType["UsersNotInGroup"] = "USERS_NOT_IN_GROUP";
  ReportJobType["UserAccountActivity"] = "USER_ACCOUNT_ACTIVITY";
  ReportJobType["UserActivity"] = "USER_ACTIVITY";
  ReportJobType["UserActivityAllUsers"] = "USER_ACTIVITY_ALL_USERS";
  ReportJobType["UserActivityAllUsersV2"] = "USER_ACTIVITY_ALL_USERS_V2";
  ReportJobType["UserActivityTrending"] = "USER_ACTIVITY_TRENDING";
  ReportJobType["UserActivityV2"] = "USER_ACTIVITY_V2";
  ReportJobType["UserAdoption"] = "USER_ADOPTION";
  ReportJobType["UserAdoptionNotEnrolled"] = "USER_ADOPTION_NOT_ENROLLED";
  ReportJobType["UserAdoptionNotWatched"] = "USER_ADOPTION_NOT_WATCHED";
  ReportJobType["UserAssessmentActivity"] = "USER_ASSESSMENT_ACTIVITY";
  ReportJobType["UserAssessmentProficiency"] = "USER_ASSESSMENT_PROFICIENCY";
  ReportJobType["UserBadgeActivity"] = "USER_BADGE_ACTIVITY";
  ReportJobType["UserCourseActivity"] = "USER_COURSE_ACTIVITY";
  ReportJobType["UserLabActivity"] = "USER_LAB_ACTIVITY";
  ReportJobType["UserProgress"] = "USER_PROGRESS";
  ReportJobType["UserRolePlayActivity"] = "USER_ROLE_PLAY_ACTIVITY";
  ReportJobType["UserSkillsActivity"] = "USER_SKILLS_ACTIVITY";
  ReportJobType["UserSkillsProficiency"] = "USER_SKILLS_PROFICIENCY";
  return ReportJobType;
}({});

/** Defines assistant's response type */
export let ResponseType = /*#__PURE__*/function (ResponseType) {
  ResponseType["Audio"] = "AUDIO";
  ResponseType["Text"] = "TEXT";
  return ResponseType;
}({});

/** A review of a learning product */

/** Role-play activity for students to practice soft skills */

/** Schedule configuration */

/** Input type for schedule configuration */

/** Frequency of a schedule */
export let ScheduleFrequency = /*#__PURE__*/function (ScheduleFrequency) {
  ScheduleFrequency["Monthly"] = "MONTHLY";
  ScheduleFrequency["Quarterly"] = "QUARTERLY";
  ScheduleFrequency["Weekly"] = "WEEKLY";
  ScheduleFrequency["Yearly"] = "YEARLY";
  return ScheduleFrequency;
}({});

/** Recurring scheduled report */

/** Input types for creating/updating scheduled reports */

/** Response object for scheduled report creation */

/** Identifies available search filter facets. */

/** Options for search aggregates */

/** One of the available options within a search facet type */

/** A simple auto-complete item can be search log, course or instructor */

/** Search Log suggestion for autocomplete */

/** Info about the page or component that sends the request */

/** Search Autocomplete request filters */

/** Search Autocomplete request metadata */

/** A simple autocomplete item with the tracking metadata */

/** Represents a search suggestion for a search */

/** Possible suggestion types for the search query. */
export let SearchQuerySuggestionType = /*#__PURE__*/function (SearchQuerySuggestionType) {
  SearchQuerySuggestionType["DidYouMean"] = "DID_YOU_MEAN";
  SearchQuerySuggestionType["Rewrite"] = "REWRITE";
  return SearchQuerySuggestionType;
}({});

/** Trigger types for the lab, lecture, assessment and path search. */
export let SearchTriggerType = /*#__PURE__*/function (SearchTriggerType) {
  SearchTriggerType["ChatgptApp"] = "CHATGPT_APP";
  SearchTriggerType["McpServer"] = "MCP_SERVER";
  SearchTriggerType["UserQuery"] = "USER_QUERY";
  return SearchTriggerType;
}({});

/** Security-related organization settings */

/** A skills framework is a collection of learning objectives that are organized into a hierarchy. */

/** The goal for a skills framework which contains a set of learning objectives. */
export let SkillsFrameworkGoalType = /*#__PURE__*/function (SkillsFrameworkGoalType) {
  SkillsFrameworkGoalType["Blueprint"] = "BLUEPRINT";
  SkillsFrameworkGoalType["BottomUp"] = "BOTTOM_UP";
  SkillsFrameworkGoalType["OpenBadge"] = "OPEN_BADGE";
  SkillsFrameworkGoalType["OrgUpskill"] = "ORG_UPSKILL";
  return SkillsFrameworkGoalType;
}({});

/** A SkillsFramework Id Input is used to identify a skills framework by id and type. */

/** To save a SkillsFramework we need the name and learning objectives associated with it */

/** Response for mapping content to skills framework task reference id status */

/** Content mapping task id and current mapping task status */

/** Status of map content for a reference Id */
export let SkillsFrameworkMapContentTaskStatus = /*#__PURE__*/function (SkillsFrameworkMapContentTaskStatus) {
  SkillsFrameworkMapContentTaskStatus["Failed"] = "FAILED";
  SkillsFrameworkMapContentTaskStatus["InProgress"] = "IN_PROGRESS";
  SkillsFrameworkMapContentTaskStatus["Killed"] = "KILLED";
  SkillsFrameworkMapContentTaskStatus["Success"] = "SUCCESS";
  return SkillsFrameworkMapContentTaskStatus;
}({});

/** This is the response for updating a skills framework */

/** A skills framework is a collection of learning objectives that are organized into a hierarchy. */

/** Holds a list events by skill node */

/** A skills preparation learning event */

/** Type of a skills preparation learning event */
export let SkillsPrepLearningEventType = /*#__PURE__*/function (SkillsPrepLearningEventType) {
  SkillsPrepLearningEventType["Completed"] = "COMPLETED";
  SkillsPrepLearningEventType["Failed"] = "FAILED";
  return SkillsPrepLearningEventType;
}({});

/** A list of learning events corresponding to one skill node */

/** Status for a user's skills preparation */
export let SkillsPrepStatus = /*#__PURE__*/function (SkillsPrepStatus) {
  SkillsPrepStatus["Abandoned"] = "ABANDONED";
  SkillsPrepStatus["Completed"] = "COMPLETED";
  SkillsPrepStatus["Started"] = "STARTED";
  return SkillsPrepStatus;
}({});

/** The filter parameters for skills proficiency insights queries */

/** High-level metrics for skills proficiency across an organization */

/** Represents an Slide with its current time of a Video Mashup asset */

/** Sort direction */
export let SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection["Ascending"] = "ASCENDING";
  SortDirection["Descending"] = "DESCENDING";
  return SortDirection;
}({});

/** SSO-related organization settings */

/** Details about a user's lecture minutes consumption streak, including what to achieve by what date */

/** Status of any type of streak */
export let StreakStatus = /*#__PURE__*/function (StreakStatus) {
  StreakStatus["ActiveCurrentPeriodAchieved"] = "ACTIVE_CURRENT_PERIOD_ACHIEVED";
  StreakStatus["ActiveCurrentPeriodUnachieved"] = "ACTIVE_CURRENT_PERIOD_UNACHIEVED";
  StreakStatus["Dropped"] = "DROPPED";
  StreakStatus["ZeroHistory"] = "ZERO_HISTORY";
  return StreakStatus;
}({});

/** SubCategory interface */

/** A wrapper type to include the recommended SubCategory and some additional fields about its recommendation */

/** Subcategory navigation list item. */

/** Subscription plan that the subscriber is subscribed to */

/** Subscriber of the subscription */

/** Subscriber Type */
export let SubscriberType = /*#__PURE__*/function (SubscriberType) {
  SubscriberType["Organization"] = "ORGANIZATION";
  SubscriberType["User"] = "USER";
  return SubscriberType;
}({});

/** Billing details of a subscription */

/** Credit card used for the subscription */

/** Subscription object that represents consumer and UB subscriptions */

/** Response for subscription enrollment update mutations */

/** Subscription Feature */

/** Subscription Feature Availability */

/** Subscription Feature Key */
export let SubscriptionFeatureKey = /*#__PURE__*/function (SubscriptionFeatureKey) {
  SubscriptionFeatureKey["AiElevateExperience"] = "AI_ELEVATE_EXPERIENCE";
  SubscriptionFeatureKey["AiStarterPaths"] = "AI_STARTER_PATHS";
  SubscriptionFeatureKey["CategoryNavigation"] = "CATEGORY_NAVIGATION";
  SubscriptionFeatureKey["CertificateContent"] = "CERTIFICATE_CONTENT";
  SubscriptionFeatureKey["CommentingOnInstructorAnnouncements"] = "COMMENTING_ON_INSTRUCTOR_ANNOUNCEMENTS";
  SubscriptionFeatureKey["ContentDiscoveryAiAssistant"] = "CONTENT_DISCOVERY_AI_ASSISTANT";
  SubscriptionFeatureKey["CourseRecommendationsForLearningPathsCreation"] = "COURSE_RECOMMENDATIONS_FOR_LEARNING_PATHS_CREATION";
  SubscriptionFeatureKey["CreateCourses"] = "CREATE_COURSES";
  SubscriptionFeatureKey["Dei"] = "DEI";
  SubscriptionFeatureKey["DirectMessaging"] = "DIRECT_MESSAGING";
  SubscriptionFeatureKey["Drm"] = "DRM";
  SubscriptionFeatureKey["DynamicLectureArticles"] = "DYNAMIC_LECTURE_ARTICLES";
  SubscriptionFeatureKey["Groups"] = "GROUPS";
  SubscriptionFeatureKey["HideOrgWideLearnerData"] = "HIDE_ORG_WIDE_LEARNER_DATA";
  SubscriptionFeatureKey["ImportCourses"] = "IMPORT_COURSES";
  SubscriptionFeatureKey["InCourseAssignments"] = "IN_COURSE_ASSIGNMENTS";
  SubscriptionFeatureKey["LearningStreaks"] = "LEARNING_STREAKS";
  SubscriptionFeatureKey["LeavingReviews"] = "LEAVING_REVIEWS";
  SubscriptionFeatureKey["ManageLicenses"] = "MANAGE_LICENSES";
  SubscriptionFeatureKey["McpServer"] = "MCP_SERVER";
  SubscriptionFeatureKey["MobileApp"] = "MOBILE_APP";
  SubscriptionFeatureKey["OrganizationBadges"] = "ORGANIZATION_BADGES";
  SubscriptionFeatureKey["OrganizationBadgesForLearners"] = "ORGANIZATION_BADGES_FOR_LEARNERS";
  SubscriptionFeatureKey["QuestionAndAnswer"] = "QUESTION_AND_ANSWER";
  SubscriptionFeatureKey["Recommend"] = "RECOMMEND";
  SubscriptionFeatureKey["Resources"] = "RESOURCES";
  SubscriptionFeatureKey["Scim"] = "SCIM";
  SubscriptionFeatureKey["ShowcasePaths"] = "SHOWCASE_PATHS";
  SubscriptionFeatureKey["SkillsBenchmarking"] = "SKILLS_BENCHMARKING";
  SubscriptionFeatureKey["UploadBadges"] = "UPLOAD_BADGES";
  SubscriptionFeatureKey["VideoPlayerDisplayAds"] = "VIDEO_PLAYER_DISPLAY_ADS";
  return SubscriptionFeatureKey;
}({});

/** Subscription Feature Override */

/** Subscription Feature Override Input */

/** Response for the Subscription Feature Set Overrides mutations */

/** Mobile in-app subscription (through iOS or Android) */

/** Mobile platform that the subscription has been purchased */
export let SubscriptionMobilePlatform = /*#__PURE__*/function (SubscriptionMobilePlatform) {
  SubscriptionMobilePlatform["Android"] = "ANDROID";
  SubscriptionMobilePlatform["Ios"] = "IOS";
  return SubscriptionMobilePlatform;
}({});

/** PayPal payment method for the subscription */

/** Payment method of the subscription */

/** Payment type for subscription billing */
export let SubscriptionPaymentType = /*#__PURE__*/function (SubscriptionPaymentType) {
  SubscriptionPaymentType["ApplePay"] = "APPLE_PAY";
  SubscriptionPaymentType["CreditCard"] = "CREDIT_CARD";
  SubscriptionPaymentType["GooglePay"] = "GOOGLE_PAY";
  SubscriptionPaymentType["NativeApp"] = "NATIVE_APP";
  SubscriptionPaymentType["PaypalOverStripe"] = "PAYPAL_OVER_STRIPE";
  return SubscriptionPaymentType;
}({});

/** A Subscription plan to access a catalog of Udemy content */

/** A Subscription plan to access a catalog of Udemy content */

/** Contains information about the discount metadata for a given subscription plan price option */

/** Details of the specific discount type */

/** Contains information on the start and end perioid for the discount interval type can be month/year */

/** Discount details for applied discount */

/** enum definition for different discount types for subscription */
export let SubscriptionPlanDiscountType = /*#__PURE__*/function (SubscriptionPlanDiscountType) {
  SubscriptionPlanDiscountType["PlanPriceDiscount"] = "PLAN_PRICE_DISCOUNT";
  SubscriptionPlanDiscountType["TrialDiscount"] = "TRIAL_DISCOUNT";
  return SubscriptionPlanDiscountType;
}({});

/** Filers for subscription plans */

/** Contains information about the license context for a given subscription plan price option */

/** Price data for plan pricing options */

/** Contains information on the plan price discount */

/** Definition for different price discount types */
export let SubscriptionPlanPriceDiscountType = /*#__PURE__*/function (SubscriptionPlanPriceDiscountType) {
  SubscriptionPlanPriceDiscountType["Fixed"] = "FIXED";
  SubscriptionPlanPriceDiscountType["Percentage"] = "PERCENTAGE";
  return SubscriptionPlanPriceDiscountType;
}({});

/** Union of possible plan pricing options */

/** A subscription plan product family */
export let SubscriptionPlanProductFamily = /*#__PURE__*/function (SubscriptionPlanProductFamily) {
  SubscriptionPlanProductFamily["Consumer"] = "CONSUMER";
  SubscriptionPlanProductFamily["Enterprise"] = "ENTERPRISE";
  SubscriptionPlanProductFamily["Team"] = "TEAM";
  return SubscriptionPlanProductFamily;
}({});

/** The type of subscription plan being offered */
export let SubscriptionPlanProductType = /*#__PURE__*/function (SubscriptionPlanProductType) {
  SubscriptionPlanProductType["Consumersubscription"] = "CONSUMERSUBSCRIPTION";
  SubscriptionPlanProductType["ConsumersubscriptionPlusGrowWithGoogle"] = "CONSUMERSUBSCRIPTION_PLUS_GROW_WITH_GOOGLE";
  SubscriptionPlanProductType["ConsumersubscriptionValuePlan"] = "CONSUMERSUBSCRIPTION_VALUE_PLAN";
  SubscriptionPlanProductType["Enterprise"] = "ENTERPRISE";
  SubscriptionPlanProductType["Enterprisepro"] = "ENTERPRISEPRO";
  SubscriptionPlanProductType["EnterpriseAiGrowth"] = "ENTERPRISE_AI_GROWTH";
  SubscriptionPlanProductType["EnterpriseAiReadiness"] = "ENTERPRISE_AI_READINESS";
  SubscriptionPlanProductType["EnterpriseBase"] = "ENTERPRISE_BASE";
  SubscriptionPlanProductType["GrowWithGoogle"] = "GROW_WITH_GOOGLE";
  SubscriptionPlanProductType["Team"] = "TEAM";
  SubscriptionPlanProductType["Udemypro"] = "UDEMYPRO";
  return SubscriptionPlanProductType;
}({});

/** contains information on the trial discount if available */

/** Status of the subscription */
export let SubscriptionStatus = /*#__PURE__*/function (SubscriptionStatus) {
  SubscriptionStatus["Active"] = "ACTIVE";
  SubscriptionStatus["Canceled"] = "CANCELED";
  SubscriptionStatus["Expired"] = "EXPIRED";
  SubscriptionStatus["Future"] = "FUTURE";
  SubscriptionStatus["Trial"] = "TRIAL";
  return SubscriptionStatus;
}({});

/** Type representing details about the trial subscription offer available for a given user and plan */

/** Represents a badge awarded to a top-rated category topic. */

/** Represents a badge awarded to a top-rated subcategory. */

/** Represents a badge awarded to a top-rated subcategory topic. */

/** Topic */

/** Topic Filters for searching topics. All filters are ANDed together. */

/** Topic Group */

/** Response for topic interest update mutations */

/** Types of popularity for Topics */
export let TopicPopularityTypes = /*#__PURE__*/function (TopicPopularityTypes) {
  TopicPopularityTypes["Popular"] = "POPULAR";
  TopicPopularityTypes["Trending"] = "TRENDING";
  return TopicPopularityTypes;
}({});

/** A question and answer pair with optional link for additional context */

/** A wrapper type to include the recommended Topic (aka. Label) and some additional fields about its recommendation */

/** List of assessment metrics related to a topic */

/** Paginated list for topic-to-assessment summary list */

/**
 * If backend generates a tracking ID for any part of the response, and if the tracking ID ıs needed in the frontend, the
 * object should implement this interface.
 */

/** A Udemy user */

/** Represents the each notification preference of a user */

/** Represents the users notification preference */

/** Input for update for notification preferences  */

/** Response of update user notification preferences */

/** Type of notification preferences */
export let UserNotificationType = /*#__PURE__*/function (UserNotificationType) {
  UserNotificationType["All"] = "ALL";
  UserNotificationType["AssetReady"] = "ASSET_READY";
  UserNotificationType["CourseAnnouncement"] = "COURSE_ANNOUNCEMENT";
  UserNotificationType["CourseMessageNotification"] = "COURSE_MESSAGE_NOTIFICATION";
  UserNotificationType["CoursePromotion"] = "COURSE_PROMOTION";
  UserNotificationType["CourseRecommendations"] = "COURSE_RECOMMENDATIONS";
  UserNotificationType["DailyDiscussionsDigest"] = "DAILY_DISCUSSIONS_DIGEST";
  UserNotificationType["EnterpriseUbOfferings"] = "ENTERPRISE_UB_OFFERINGS";
  UserNotificationType["InstructorAnnouncement"] = "INSTRUCTOR_ANNOUNCEMENT";
  UserNotificationType["LearningInspiration"] = "LEARNING_INSPIRATION";
  UserNotificationType["LearningStats"] = "LEARNING_STATS";
  UserNotificationType["MessageNotification"] = "MESSAGE_NOTIFICATION";
  UserNotificationType["OffersPromotions"] = "OFFERS_PROMOTIONS";
  UserNotificationType["ProductAnnouncements"] = "PRODUCT_ANNOUNCEMENTS";
  UserNotificationType["Promotional"] = "PROMOTIONAL";
  UserNotificationType["VideoUploadError"] = "VIDEO_UPLOAD_ERROR";
  return UserNotificationType;
}({});

/** Shows details of the user's occupation */

/** Mutation response for occupation info update */

/** Represents the basic information of a user */

/** Represents different sizes of the same image */

/** A versioned identifier type */

/** A versioned identifier input */

/** Video lecture */

/** Video lecture */

/** Length of the video in course */
export let VideoLength = /*#__PURE__*/function (VideoLength) {
  VideoLength["ExtraLong"] = "EXTRA_LONG";
  VideoLength["ExtraShort"] = "EXTRA_SHORT";
  VideoLength["Long"] = "LONG";
  VideoLength["Medium"] = "MEDIUM";
  VideoLength["Short"] = "SHORT";
  return VideoLength;
}({});

/** Mashup lecture has both video and a presentation */

/** Mashup lecture has both video and a presentation */

/** Voucher pool product types */
export let VoucherPoolProductType = /*#__PURE__*/function (VoucherPoolProductType) {
  VoucherPoolProductType["Default"] = "DEFAULT";
  VoucherPoolProductType["RetakeInsurance"] = "RETAKE_INSURANCE";
  return VoucherPoolProductType;
}({});

/** Contains metadata about any retention streak */

/** Price option for computed price plan. Will be returned for weekly plans */

export const AutocompleteSuggestionsDocument = `
    query AutocompleteSuggestions($searchedPhrase: String!, $filters: SearchAutocompleteRequestFilters!, $limit: PositiveInt, $metadata: SearchAutocompleteRequestMetadata) {
  searchAutocomplete(
    query: $searchedPhrase
    filters: $filters
    limit: $limit
    metadata: $metadata
  ) {
    item {
      ... on SearchAutocompleteLogItem {
        phrase: title
        sectionLabel
        sectionKey
        __typename
      }
      ... on CourseInstructor {
        id
        name
        url
        images {
          px50x50
        }
        __typename
      }
      ... on Course {
        id
        title
        urlCourseLanding
        instructors {
          name
        }
        images {
          px50x50
        }
        __typename
      }
    }
    resultTrackingId
    trackingId
  }
}
    `;
export const useAutocompleteSuggestionsQuery = (variables, options) => useQuery(['AutocompleteSuggestions', variables], fetcher(AutocompleteSuggestionsDocument, variables), options);
useAutocompleteSuggestionsQuery.getKey = variables => ['AutocompleteSuggestions', variables];
useAutocompleteSuggestionsQuery.fetcher = (variables, options) => fetcher(AutocompleteSuggestionsDocument, variables, options);
//# sourceMappingURL=api-platform-graphql.js.map